import React, { useEffect, useState, useRef } from "react";
import { createBuy, updatePurchase } from "./../services/buy.service";
import { Formik, Form, Field } from "formik";
import {
  evaluateExpression,
  onlyNumber,
  onlyNumberdesimal,
  onlyNumberWithExpression,
} from "../helpers/formats";
import CustomField from "./common/customField";
import { toast } from "react-toastify";
import { Country, State } from "country-state-city";
import { FaChevronUp } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa6";
import { FiArrowLeft } from "react-icons/fi";
import {
  optionsForTransactionStatus,
  optionsForOrderStatus,
  optionsForSupplierType,
  generateOptionsForSubstitute,
  STATE_CODE_MAP,
} from "./common/utlity/options";
import { initialValuesForPurchase } from "./common/utlity/intialValues";
import { purchaseValidationSchema } from "./common/utlity/validationSchema";
import { getSuppliersData, getBuysData } from "../store/actions/action";
import { useDispatch, useSelector } from "react-redux";
import "../components/common/text-color/textColor.css";
import { getProducts, getServices } from "../services/inventory.service";
import BeatLoader from "react-spinners/BeatLoader";
import { useParams, useNavigate } from "react-router-dom";
import { BsTrash } from "react-icons/bs";
import { FormControlLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import ProductSelection from "./productSelection";
import Modal from "./common/modal/Modal";
import { transformProducts } from "./common/utlity/sale.utility";
import { getPitaraProducts } from "../services/pitara.services";
import PaymentOptions from "../pages/sale/SalePayment";
import SalePaylater from "../pages/sale/SalePayLater";
import { generateEanId, generateHexTimeId } from "./common/utlity/utility";
import { Tooltip } from "react-tooltip";
import "./common.css";
import { HiOutlineMicrophone } from "react-icons/hi";
import CustomPhoneNumberField from "../components/common/customPhone";
import { useTranslation } from "react-i18next";
import {
  getCurrencySymbol,
  optionsForUnitSize,
} from "../components/common/utlity/options";
import AutoCompleteFieldForTaxDetails from "./autoCompleteForPuchase";
import taxDetails from "../assets/hsn_data.json";
import { useLocation } from "react-router-dom";
import TourGuide from "./common/TourGuide";
import { BuySteps } from "../lib/constants/TourSteps";
import InvoiceUploader from "./invoiceUploader/InvoiceUploader";
import { mapInvoiceDataToForm } from "./common/utlity/invoiceMapping";
import {
  FiChevronDown,
  FiChevronUp,
  FiPercent,
  FiMap,
  FiCheckCircle,
  FiNavigation,
  FiCheck,
  FiPackage,
  FiUpload,
} from "react-icons/fi";
// import { ToggleButton } from "./common/commonLable";
import { getRawMaterialsData } from "../store/actions/action";
import { verifyGSTService } from "../services/sale.service";
import { generateVariantName } from "./variant/varianthelper";
import { VariantModal } from "./variant/variantModelsSaleBuy";
import { useBusinessSettings } from "./sidebar/BusinessSettingsContext";

const NewBuy = ({
  close,
  addBuy,
  updateBuy,
  item,
  purchaseNumber,
  businessUuid,
  initialValues,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { bussinessUuid: paramUuid } = useParams();
  const finalBusinessUuid = businessUuid || paramUuid;
  let location = useLocation();

  const suppliers = useSelector((state) => state?.suppliers?.suppliers);
  const buys = useSelector((state) => state?.buys?.buys);
  const rawMaterials =
    useSelector((state) => state?.RawMatarial.rawMaterials) || [];
  const [rawMaterialsLocal, setRawMaterialsLocal] = useState(rawMaterials);
  const [products, setProducts] = useState([]);
  const businessData = useSelector((state) => state.bussiness.business);
  const business = Array.isArray(businessData)
    ? businessData.find((b) => b.bussinessUuid === finalBusinessUuid) ||
      businessData[0]
    : businessData;
  const [intraState, setIntraState] = useState(item ? item.intraState : false);
  const [service, setService] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [purchaseIsLoading, setPurchaseIsLoading] = useState(false);
  const user = useSelector((state) => state.user.user);
  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [itc, setItc] = useState(item?.itc || false);
  const [isOpen, setIsOpen] = useState(false);
  const [rcm, setRcm] = useState(item?.rcm || false);
  const [importPurchaseGoods, setImportPurchase] = useState(
    item?.importPurchaseGoods || false,
  );
  const [isOpenFullPayment, setIsOpenFullPayment] = useState(false);
  const [showInvoiceUploader, setShowInvoiceUploader] = useState(false);
  const [isOpenPayPartial, setIsOpenPayPartial] = useState(false);
  const [showReceiptOptions, setShowReceiptOptions] = useState(false);
  const [pendingPurchaseValues, setPendingPurchaseValues] = useState(null);
  const [askSalePrice, setAskSalePrice] = useState(false);
  const [salePrices, setSalePrices] = useState({});
  const [batchNumbers, setBatchNumbers] = useState({});
const [variantSetupIndex, setVariantSetupIndex] = useState(null);
const [variantSetupData, setVariantSetupData] = useState(null);
const [pendingUpdateValues, setPendingUpdateValues] = useState(null);
  const [visibleFields, setVisibleFields] = useState({
    hsn: !item?.items?.hsnNumber,
    discount: !item?.items?.discount,
    otherFee: !item?.items?.otherFee,
  });
  const navigate = useNavigate();

  const { settings: businessSettings } = useBusinessSettings();
  const purchaseSettings = businessSettings?.purchaseSettings;
  const disabledPurchaseFields = {
    hsn: purchaseSettings?.controls?.enableHSN === false,
    discount: purchaseSettings?.controls?.enableDiscount === false,
  };
  const showItc = purchaseSettings?.modules?.ITC !== false;
  const showRcm = purchaseSettings?.modules?.RCM !== false;
  const showImport = purchaseSettings?.modules?.importPurchase !== false;
  const hideDiscount = disabledPurchaseFields.discount;
  const hideHsn = disabledPurchaseFields.hsn;

  useEffect(() => {
    setVisibleFields((prev) =>
      (hideHsn && prev.hsn) || (hideDiscount && prev.discount)
        ? {
            ...prev,
            hsn: hideHsn ? false : prev.hsn,
            discount: hideDiscount ? false : prev.discount,
          }
        : prev,
    );
  }, [hideHsn, hideDiscount, visibleFields.hsn, visibleFields.discount]);

  //for dynamic fields filter
  const [showFilter, setShowFilter] = useState(false);

  // Product sections state with variant support
  const [productSections, setProductSections] = useState([
    {
      quantity: 1,
      purchasePrice: "",
      discount: "",
      productName: "",
      igst: "0",
      finalPrice: "",
      productId: "",
      cgst: "0",
      sgst: "0",
      cess: "0",
      otherFee: "",
      costPerUnit: 0,
      hsnNumber: "",
      discountUnit: "%",
      mrp: "",
      openingStock: "",
      lowStock: "",
      ean: generateHexTimeId(),
      sku_number: generateEanId(),
      LRNumber: "",
      logisticName: "",
      logisticVehicle: "",
      // Variant fields
      hasVariants: false,
      variantType: "size",
      variantConfig: {
        color: ["Red", "Blue", "Green", "Black", "White"],
        size: ["S", "M", "L", "XL"],
        model: [],
        custom: [],
      },
      variants: [],
    },
  ]);

  const section = productSections[0];
  const [filteredSuppliers, setFilteredSuppliers] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [additionalInfo, setAdditionalInfo] = useState(false);
  const [expandedAdditionalInfo, setExpandedAdditionalInfo] = useState(
  new Set(),
);
  const [isOpenPitara, setIsOpenPitara] = useState(false);
  const [disableName, setDisableName] = useState(item ? true : false);
  const [pitaraProducts, setPiataProducts] = useState([]);
  const [activeVoiceIndex, setActiveVoiceIndex] = useState(null);
  const [isProducts, setIsProducts] = useState(
    location?.state?.isServices ? false : (item?.isProducts ?? true),
  );
  const [isServices, setIsServices] = useState(
    item?.isServices || location?.state?.isServices || false,
  );
  const [isRawMaterials, setIsRawMaterials] = useState(
    item?.isRawMaterials || false,
  );
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);

  // Variant modal state
  const [isVariantModalOpen, setIsVariantModalOpen] = useState(false);
  const [currentVariantIndex, setCurrentVariantIndex] = useState(null);
  const [variantModalData, setVariantModalData] = useState({
    variantType: "size",
    variantConfig: {
      color: ["Red", "Blue", "Green", "Black", "White"],
      size: ["S", "M", "L", "XL"],
      model: [],
      custom: [],
    },
    variants: [],
  });
  const [totalVariantQuantity, setTotalVariantQuantity] = useState(0);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const handleToggleIntraState = () => {
    setIntraState(!intraState);
  };

  const [listeningIndex, setListeningIndex] = useState(null);
  const [listeningQtyIndex, setListeningQtyIndex] = useState(null);
  const [listeningSaleIndex, setListeningSaleIndex] = useState(null);
  const [listeningcgstIndex, setListeningcgstIndex] = useState(null);
  const [listeningigstIndex, setListeningigstIndex] = useState(null);
  const [listeningsgstIndex, setListeningsgstIndex] = useState(null);
  const [listeningcessIndex, setListeningcessIndex] = useState(null);
  const [listeningproductIndex, setListeningproductIndex] = useState(null);
  const [isMicActive, setIsMicActive] = useState(false);
  const [runTour, setRunTour] = useState(false);

  useEffect(() => {
    setRawMaterialsLocal(rawMaterials);
  }, [rawMaterials]);

  useEffect(() => {
    dispatch(getRawMaterialsData(finalBusinessUuid));
  }, [dispatch, finalBusinessUuid, t]);

  useEffect(() => {
    const waitForElements = () => {
      const allElementsExist =
        document.querySelector(".order-status-tour") &&
        document.querySelector(".transaction-status-tour");

      if (buys?.length === 0 && allElementsExist) {
        setRunTour(true);
      } else {
        setTimeout(waitForElements, 300);
      }
    };

    waitForElements();
  }, [buys]);

  const handleIsOpen = () => {
    setIsOpen(!isOpen);
  };
const generateDefaultBatch = (item, values) => {
  const initials = (item?.productName || "PR")
    .split(" ")
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
  const supplierInitial = (values?.fullName || "S").charAt(0).toUpperCase();
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yy = String(today.getFullYear()).slice(-2);
  return `${initials}${supplierInitial}${dd}${mm}${yy}-01`;
};

// Purchase price per unit, tax + discount included — matches costPerUnit in PurchaseProductList
const getPurchasePricePerUnit = (section) => {
  const finalPrice = Number(section?.finalPrice) || 0;
  const qty = Number(section?.quantity) || 0;
  if (qty > 0 && finalPrice > 0) return Number((finalPrice / qty).toFixed(2));
  return Number(section?.purchasePrice) || 0;
};

const totalVariantQuantityForSection = (section) =>
  (section.variants || []).reduce(
    (sum, v) => sum + (Number(v.quantity) || 0),
    0,
  );
  const handleInvoiceDataExtracted = (extractedData) => {
    if (!formikRef.current) return;

    const { setFieldValue } = formikRef.current;

    mapInvoiceDataToForm(
      extractedData,
      setFieldValue,
      setProductSections,
      setIntraState,
    );

    setShowInvoiceUploader(false);

    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleVoiceSearch = async (index) => {
    setListeningproductIndex(index);
    setIsMicActive(true);
    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-US";
    recognition.onresult = async (event) => {
      const voiceInput = event.results[0][0].transcript;
      await handleInputChange(index, "productName", voiceInput);
      await handleInputSearch(voiceInput, index);
    };
    recognition.start();
    recognition.onerror = (event) => {
      toast.error("An error occurred during voice recognition.");
      setIsMicActive(false);
      setListeningproductIndex(null);
    };
    recognition.onend = () => {
      setIsMicActive(false);
      setListeningproductIndex(null);
    };
    setTimeout(() => {
      setListeningproductIndex(null);
      setIsMicActive(false);
    }, 5000);
  };

  const handleVoiceSearchForPurchasePrice = async (index) => {
    setListeningIndex(index);
    setIsMicActive(true);

    if (!window.webkitSpeechRecognition) {
      toast.error("Your browser does not support voice recognition.");
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-US";

    recognition.onresult = async (event) => {
      const voiceInput = event.results[0][0].transcript;
      const cleanedInput = voiceInput.replace(/[^0-9.]/g, "");

      if (cleanedInput && !isNaN(parseFloat(cleanedInput))) {
        await handleInputChange(index, "purchasePrice", cleanedInput);
        await handleInputSearch(cleanedInput, index);
      } else {
        toast.error("Please say a valid number for the purchase price.");
      }
    };

    recognition.onerror = (event) => {
      toast.error("An error occurred during voice recognition.");
      setIsMicActive(false);
      setListeningIndex(null);
    };

    recognition.onend = () => {
      setIsMicActive(false);
      setListeningIndex(null);
    };

    recognition.start();
    setTimeout(() => {
      setListeningIndex(null);
      setIsMicActive(false);
    }, 5000);
  };

  const handleVoiceSearchForSalePrice = async (index) => {
    setListeningSaleIndex(index);
    setIsMicActive(true);
    if (!window.webkitSpeechRecognition) {
      toast.error("Your browser does not support voice recognition.");
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-US";

    recognition.onresult = async (event) => {
      const voiceInput = event.results[0][0].transcript;
      const cleanedInput = voiceInput.replace(/[^0-9.]/g, "");

      if (cleanedInput && !isNaN(parseFloat(cleanedInput))) {
        await handleInputChange(index, "otherFee", cleanedInput);
        await handleInputSearch(cleanedInput, index);
      } else {
        toast.error("Please say a valid number for the purchase price.");
      }
    };

    recognition.onerror = (event) => {
      toast.error("An error occurred during voice recognition.");
      setIsMicActive(false);
      setListeningSaleIndex(null);
    };

    recognition.onend = () => {
      setIsMicActive(false);
      setListeningSaleIndex(null);
    };

    recognition.start();
    setTimeout(() => {
      setListeningSaleIndex(null);
      setIsMicActive(false);
    }, 5000);
  };

  const handleVoiceSearchForQuantity = async (index) => {
    setListeningQtyIndex(index);
    setIsMicActive(true);

    if (!window.webkitSpeechRecognition) {
      toast.error("Your browser does not support voice recognition.");
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-US";

    recognition.onresult = async (event) => {
      const voiceInput = event.results[0][0].transcript;
      const cleanedInput = voiceInput.replace(/[^0-9.]/g, "");

      if (cleanedInput && !isNaN(parseFloat(cleanedInput))) {
        await handleInputChange(index, "quantity", cleanedInput);
        await handleInputSearch(cleanedInput, index);
      } else {
        toast.error("Please say a valid number for the Quantity");
      }
    };

    recognition.onerror = (event) => {
      toast.error("An error occurred during voice recognition.");
      setIsMicActive(false);
      setListeningQtyIndex(null);
    };

    recognition.onend = () => {
      setIsMicActive(false);
      setListeningQtyIndex(null);
    };

    recognition.start();
    setTimeout(() => {
      setListeningQtyIndex(null);
      setIsMicActive(false);
    }, 5000);
  };

  const handleVoiceSearchForDiscount = (index) => {
    setActiveVoiceIndex(index);
    setIsMicActive(true);

    if (!window.webkitSpeechRecognition) {
      toast.error("Your browser does not support voice recognition.");
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-US";

    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onresult = async (event) => {
      const voiceInput = event.results[0][0].transcript.trim();
      const cleanedInput = voiceInput.replace(/[^0-9.]/g, "");

      if (cleanedInput && !isNaN(parseFloat(cleanedInput))) {
        await handleInputChange(index, "discount", cleanedInput);
        await handleInputSearch(cleanedInput, index);
      } else {
        toast.error("Please say a valid number for the discount.");
      }
    };

    recognition.onerror = (event) => {
      toast.error("An error occurred during voice recognition.");
      setIsMicActive(false);
      setActiveVoiceIndex(null);
    };

    recognition.onend = () => {
      setIsMicActive(false);
      setActiveVoiceIndex(null);
    };

    recognition.start();
    setTimeout(() => {
      setActiveVoiceIndex(null);
      setIsMicActive(false);
    }, 5000);
  };

  const handleVoiceSearchForcgst = (index) => {
    setListeningcgstIndex(index);
    setIsMicActive(true);

    if (!window.webkitSpeechRecognition) {
      toast.error("Your browser does not support voice recognition.");
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-US";

    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onresult = async (event) => {
      const voiceInput = event.results[0][0].transcript.trim();
      const cleanedInput = voiceInput.replace(/[^0-9.]/g, "");

      if (cleanedInput && !isNaN(parseFloat(cleanedInput))) {
        await handleInputChange(index, "cgst", cleanedInput);
        await handleInputSearch(cleanedInput, index);
      } else {
        toast.error("Please say a valid number for the discount.");
      }
    };

    recognition.onerror = (event) => {
      toast.error("An error occurred during voice recognition.");
      setIsMicActive(false);
      setListeningcgstIndex(null);
    };

    recognition.onend = () => {
      setIsMicActive(false);
      setListeningcgstIndex(null);
    };

    recognition.start();
    setTimeout(() => {
      setListeningcgstIndex(null);
      setIsMicActive(false);
    }, 5000);
  };

  const handleVoiceSearchForigst = (index) => {
    setListeningigstIndex(index);
    setIsMicActive(true);

    if (!window.webkitSpeechRecognition) {
      toast.error("Your browser does not support voice recognition.");
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-US";

    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onresult = async (event) => {
      const voiceInput = event.results[0][0].transcript.trim();
      const cleanedInput = voiceInput.replace(/[^0-9.]/g, "");

      if (cleanedInput && !isNaN(parseFloat(cleanedInput))) {
        await handleInputChange(index, "igst", cleanedInput);
        await handleInputSearch(cleanedInput, index);
      } else {
        toast.error("Please say a valid number for the discount.");
      }
    };

    recognition.onerror = (event) => {
      toast.error("An error occurred during voice recognition.");
      setIsMicActive(false);
      setListeningigstIndex(null);
    };

    recognition.onend = () => {
      setIsMicActive(false);
      setListeningigstIndex(null);
    };

    recognition.start();
    setTimeout(() => {
      setListeningigstIndex(null);
      setIsMicActive(false);
    }, 5000);
  };

  const handleVoiceSearchForsgst = (index) => {
    setListeningsgstIndex(index);
    setIsMicActive(true);

    if (!window.webkitSpeechRecognition) {
      toast.error("Your browser does not support voice recognition.");
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-US";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onresult = async (event) => {
      const voiceInput = event.results[0][0].transcript.trim();
      const cleanedInput = voiceInput.replace(/[^0-9.]/g, "");

      if (cleanedInput && !isNaN(parseFloat(cleanedInput))) {
        await handleInputChange(index, "sgst", cleanedInput);
        await handleInputSearch(cleanedInput, index);
      } else {
        toast.error("Please say a valid number for the discount.");
      }
    };

    recognition.onerror = (event) => {
      toast.error("An error occurred during voice recognition.");
      setIsMicActive(false);
      setListeningsgstIndex(null);
    };

    recognition.onend = () => {
      setIsMicActive(false);
      setListeningsgstIndex(null);
    };

    recognition.start();
    setTimeout(() => {
      setListeningsgstIndex(null);
      setIsMicActive(false);
    }, 5000);
  };

  const handleVoiceSearchForcess = (index) => {
    setListeningcessIndex(index);
    setIsMicActive(true);

    if (!window.webkitSpeechRecognition) {
      toast.error("Your browser does not support voice recognition.");
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-US";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onresult = async (event) => {
      const voiceInput = event.results[0][0].transcript.trim();
      const cleanedInput = voiceInput.replace(/[^0-9.]/g, "");

      if (cleanedInput && !isNaN(parseFloat(cleanedInput))) {
        await handleInputChange(index, "cess", cleanedInput);
        await handleInputSearch(cleanedInput, index);
      } else {
        toast.error("Please say a valid number for the discount.");
      }
    };

    recognition.onerror = (event) => {
      toast.error("An error occurred during voice recognition.");
      setIsMicActive(false);
      setListeningcessIndex(null);
    };

    recognition.onend = () => {
      setIsMicActive(false);
      setListeningcessIndex(null);
    };

    recognition.start();
    setTimeout(() => {
      setListeningcessIndex(null);
      setIsMicActive(false);
    }, 5000);
  };

  const handleIsOpenForFullPayment = () => {
    setIsOpenFullPayment(!isOpenFullPayment);
  };

  const handleChangePaymentMethod = (value, isPartial = false) => {
    onSubmit(value);
    if (isPartial === true) {
      handleIsOpenForPayParial();
    } else {
      handleIsOpenForFullPayment();
    }
  };

  const handleIsOpenForPayParial = () => {
    setIsOpenPayPartial(!isOpenPayPartial);
  };

  const handleIsOpenPitara = () => {
    setIsOpenPitara(!isOpenPitara);
  };

  const getSetServices = async () => {
    const result = await getServices(finalBusinessUuid, { all: true });
    if (result.status === 200) {
      setService(result.data.data);
    }
  };

  useEffect(() => {
    getSetProducts();
    getsetPitara();
    getSetServices();
    const countryList = Country.getAllCountries().map((country) => ({
      label: country.name,
      value: country.isoCode,
    }));
    const stateList = State.getStatesOfCountry(user.country || "IN").map(
      (state) => ({
        label: state.name,
        value: state.isoCode,
      }),
    );
    setStates(stateList);
    setCountries(countryList);
    if (!item) return;

    const setInitialData = async () => {
      try {
        const data = item.items || [];

        const updated = data.map((product) => ({
          ean: product.ean || generateHexTimeId(),
          sku_number: product.sku_number || generateEanId(),
          hasVariants: product.hasVariants || false,
          variantType: product.variantType || "size",
          variantConfig: product.variantConfig || {
            color: ["Red", "Blue", "Green", "Black", "White"],
            size: ["S", "M", "L", "XL"],
            model: [],
            custom: [],
          },
          variants: product.variants || [],
          ...product,
        }));

        setProductSections(updated);
      } catch (error) {}
    };

    setInitialData();

    dispatch(getSuppliersData(finalBusinessUuid));
    getsetPitara();
    getSetServices();
  }, [item, dispatch, finalBusinessUuid, user.country]);

  const handleCountryChange = (setFieldValue, countryIsoCode) => {
    setFieldValue("country", countryIsoCode);
    const stateList = State.getStatesOfCountry(countryIsoCode || "IN").map(
      (state) => ({
        label: state.name,
        value: state.isoCode,
      }),
    );
    setStates(stateList);
    setFieldValue("state", "");
  };

  const handleIsProduct = (isProducts) => {
    setIsProducts(!isProducts);
    setIsServices(false);
    setIsRawMaterials(false);
  };

  const handleIsService = (isServices) => {
    setIsServices(!isServices);
    setIsProducts(false);
    setIsRawMaterials(false);
  };

  const handleIsRawMaterial = (isRawMaterials) => {
    setIsRawMaterials(!isRawMaterials);
    setIsProducts(false);
    setIsServices(false);
  };

  const getSetProducts = async () => {
    const result = await getProducts(finalBusinessUuid, { all: true });
    if (result.status === 200) {
      setProducts(result.data.data);
    }
  };

  const getsetPitara = async () => {
    const result = await getPitaraProducts();
    if (result.status === 200) {
      setPiataProducts(result.data);
    }
  };

  function calculateTotalTransactionAmount(values) {
    let totalAmount = 0;
    productSections.forEach((section) => {
      totalAmount += parseFloat(section.finalPrice) || 0;
    });

    let finalAmount = totalAmount;

    values.additionalDiscount?.forEach((item) => {
      if (item.type === "%") {
        const discountPercent = parseFloat(item.amount) || 0;
        finalAmount -= (finalAmount * discountPercent) / 100;
      } else if (item.type === "₹") {
        finalAmount -= parseFloat(item.amount) || 0;
      }
    });

    values.additionalFee?.forEach((item) => {
      if (item.type === "%") {
        // Percentage discount: add percentage of CURRENT amount
        const discountPercent = parseFloat(item.amount) || 0;
        finalAmount += (finalAmount * discountPercent) / 100;
      } else if (item.type === "₹") {
        // Fixed fee: add fixed amount
        finalAmount += parseFloat(item.amount) || 0;
      }
    });

    return finalAmount.toFixed(2);
  }

  const handleInputSearch = (e, index) => {
    const value = e.target.value;
    setActiveIndex(index);
    if (value.length > 2) {
      if (isServices === true) {
        const filteredProducts = service.filter((product) =>
          product.serviceName.toLowerCase().includes(value.toLowerCase()),
        );
        setSearchResults(filteredProducts);
      } else if (isRawMaterials === true) {
        const filteredProducts = rawMaterialsLocal.filter((product) =>
          product.rawMaterialName.toLowerCase().includes(value.toLowerCase()),
        );
        setSearchResults(filteredProducts);
      } else {
        const filteredProducts = products.filter((product) =>
          product.productName.toLowerCase().includes(value.toLowerCase()),
        );
        setSearchResults(filteredProducts);
      }
    } else {
      setSearchResults([]);
    }
  };

const handleSelectProduct = (selectedProduct, index) => {
  const updatedProductSections = [...productSections];
  updatedProductSections[index].productName =
    isServices === true
      ? selectedProduct.serviceName
      : isRawMaterials === true
        ? selectedProduct.rawMaterialName
        : selectedProduct.productName;
  updatedProductSections[index].quantity = 1;
  updatedProductSections[index]["discount"] = selectedProduct.discount || 0;
  updatedProductSections[index].finalPrice =
    isServices === true
      ? selectedProduct.serviceCost
      : selectedProduct.purchasePrice;
  updatedProductSections[index].igst = selectedProduct.igst || 0;
  updatedProductSections[index].cgst = selectedProduct.cgst || 0;
  updatedProductSections[index].sgst = selectedProduct.sgst_utgst || 0;
  updatedProductSections[index].cess = selectedProduct.cess || 0;
  updatedProductSections[index].otherFee = selectedProduct.otherFee || 0;
  updatedProductSections[index].hsnNumber = selectedProduct.hsnNumber || "";
  updatedProductSections[index]["productId"] = selectedProduct.productId;
  updatedProductSections[index]["serviceId"] = selectedProduct.serviceId;
  updatedProductSections[index]["purchasePrice"] =
    isServices === true
      ? selectedProduct.serviceCost
      : selectedProduct.purchasePrice || 0;

  setProductSections(updatedProductSections);
  setSearchResults([]);
  setActiveIndex(null);

  // Collapse this row's Additional Info panel when a new product is chosen
  setExpandedAdditionalInfo((prev) => {
    const next = new Set(prev);
    next.delete(index);
    return next;
  });
};

  // Function to open variant modal
  const openVariantModal = (productIndex) => {
    const product = productSections[productIndex];
    if (!product) return;

    setCurrentVariantIndex(productIndex);

    const orderedQty = Number(product.quantity) || 0;

    let variantDataToSet = {
      variantType: product.variantType || "size",
      variantConfig: product.variantConfig || {
        color: ["Red", "Blue", "Green", "Black", "White"],
        size: ["S", "M", "L", "XL"],
        model: [],
        custom: [],
      },
      variants: [],
    };

    // If product already has variants, use them
    if (product.hasVariants && product.variants?.length > 0) {
      variantDataToSet.variants = [...product.variants];
    } else {
      // Create default variant if quantity is greater than 0
      if (orderedQty > 0) {
        variantDataToSet.variants = [
          {
            variantId: `temp_${Date.now()}_0`,
            variantName: `Variant 1`,
            attributes: [],
            quantity: orderedQty,
            salePrice: product.salePrice || product.purchasePrice || "0",
            purchasePrice: product.purchasePrice || "0",
            batchNumber: product.batchNumber || "",
          },
        ];
      }
    }

    setVariantModalData(variantDataToSet);

    // Calculate total variant quantity
    const total = variantDataToSet.variants.reduce(
      (sum, v) => sum + (Number(v.quantity) || 0),
      0,
    );
    setTotalVariantQuantity(total);

    setIsVariantModalOpen(true);
  };

  const saveVariantsFromModal = () => {
    if (currentVariantIndex === null) return;

    const product = productSections[currentVariantIndex];
    const orderedQty = Number(product.quantity) || 0;
    const totalVariantQty = totalVariantQuantity;

    if (totalVariantQty !== orderedQty) {
      toast.error(
        `Total variant quantity (${totalVariantQty}) must equal ordered quantity (${orderedQty})`,
      );
      return;
    }

    const invalidVariants = (variantModalData.variants || []).filter(
      (v) => !v.quantity || Number(v.quantity) <= 0,
    );

    if (invalidVariants.length > 0) {
      toast.error("All variants must have a quantity greater than 0");
      return;
    }

    // Check if all variants have attributes for non-custom types
    if (variantModalData.variantType !== "custom") {
      const incompleteVariants = (variantModalData.variants || []).filter(
        (v) =>
          !v.attributes ||
          v.attributes.length === 0 ||
          (variantModalData.variantType === "size-color" &&
            v.attributes.length < 2) ||
          (variantModalData.variantType === "size-model" &&
            v.attributes.length < 2),
      );

      if (incompleteVariants.length > 0) {
        toast.error("Please fill all required attributes for each variant");
        return;
      }
    }

    // Generate unique variant IDs if not present
    const updatedVariants = variantModalData.variants.map((v, index) => {
      const variantId =
        v.variantId && !v.variantId.startsWith("temp_")
          ? v.variantId
          : `var_${Date.now()}_${index}_${Math.random().toString(36).substr(2, 6)}`;

      return {
        variantId: variantId,
        variantName:
          v.variantName ||
          generateVariantName(v.attributes, variantModalData.variantType) ||
          `Variant ${index + 1}`,
        sku:
          v.sku ||
          `${product.productId?.substring(0, 8) || "PROD"}_${Date.now().toString(36).substr(2, 6)}`,
        attributes: v.attributes ? [...v.attributes] : [],
        quantity: Number(v.quantity) || 0,
        salePrice: v.salePrice || product.salePrice || "0",
        purchasePrice: v.purchasePrice || product.purchasePrice || "0",
        mrp: v.mrp || product.mrp || "0",
        batchNumber: v.batchNumber || product.batchNumber || "",
        serialNumbers: v.serialNumbers ? [...v.serialNumbers] : [],
        lowStock: v.lowStock || product.lowStock || "0",
        openingStock: (v.quantity || "0").toString(),
        mfgDate: v.mfgDate || product.mfgDate,
        expDate: v.expDate || product.expDate,
        ...v,
      };
    });

    // Update the product section with preserved variant data
    const updatedProductSections = [...productSections];
    updatedProductSections[currentVariantIndex] = {
      ...updatedProductSections[currentVariantIndex],
      hasVariants: true,
      variantType: variantModalData.variantType,
      variantConfig: {
        color: variantModalData.variantConfig?.color || [],
        size: variantModalData.variantConfig?.size || [],
        model: variantModalData.variantConfig?.model || [],
        custom: variantModalData.variantConfig?.custom
          ? [...variantModalData.variantConfig.custom]
          : [],
      },
      variants: updatedVariants,
    };

    setProductSections(updatedProductSections);
    setIsVariantModalOpen(false);

    toast.success(
      <div>
        <div className="font-semibold">Variants configured successfully!</div>
        <div className="text-sm mt-1">
          {updatedVariants.length} variant(s) created with {totalVariantQty}{" "}
          total units.
        </div>
      </div>,
      { duration: 4000 },
    );
  };

const onSubmit = async (
  values,
  helpers,
  receiptChoice = null,
  salePriceMap = {},
  batchNumberMap = {},
) => {
  const isDraft = values?.orderStatus === "ordered";
  const willReceive =
    values?.orderStatus === "received" ||
    values?.orderStatus === "partial_received";

  if (!item && !isServices && !receiptChoice && !isDraft) {
    setPendingPurchaseValues(values);
    setShowReceiptOptions(true);
    return;
  }

  const promotedFromDraft =
    !!item && item.orderStatus === "ordered" && willReceive;

  if (
    item &&
    !receiptChoice &&
    !isDraft &&
    !promotedFromDraft &&
    item.orderStatus !== "received"
  ) {
    setPendingUpdateValues(values);
    setShowReceiptOptions(true);
    return;
  }

  const { resetForm } = helpers || {};

  if (!finalBusinessUuid) {
    toast.error("Business UUID is missing");
    return;
  }

  const dataForSave = {
    ...values,
    orderStatus: item || isServices ? values.orderStatus : "ordered",
    bussinessUuid: finalBusinessUuid,
    items: JSON.stringify(
      productSections.map((section) => ({
        ...section,
        hasVariants: section.hasVariants || false,
        variantType: section.variantType || "size",
        variantConfig: section.variantConfig || {
          color: [],
          size: [],
          model: [],
          custom: [],
        },
        variants: section.variants || [],
        quantity: Number(section.quantity) || 0,
        receivedQty:
          (item || willReceive) && values.orderStatus !== "ordered"
            ? Number(section.quantity) || 0
            : 0,
      })),
    ),
    remainingTransactionAmount:
      calculateTotalTransactionAmount(values) -
        parseFloat(values.paidAmount) || 0,
    totalPaid: values.paidAmount || 0,
    transactionAmount: calculateTotalTransactionAmount(values),
    purchaseNumber: purchaseNumber,
    itc,
    rcm,
    importPurchaseGoods,
    intraState,
    isServices,
    isProducts,
    isRawMaterials,
    additionalFee: values.additionalFee || [],
    additionalDiscount: values.additionalDiscount || [],
  };

  try {
    if (item) {
      setPurchaseIsLoading(true);
      const { buyUuid } = item;

      // If receiveNow was chosen on update, merge receipt data
      let payload = dataForSave;
      if (receiptChoice === "receiveNow") {
        const badVariant = productSections.find((s) => {
          const hasVar =
            s.hasVariants &&
            Array.isArray(s.variants) &&
            s.variants.length > 0;
          if (!hasVar) return false;
          return totalVariantQuantityForSection(s) !== Number(s.quantity);
        });
        if (badVariant) {
          toast.error(
            `"${badVariant.productName || "Item"}": variant quantities must match purchase quantity before adding to inventory.`,
          );
          setPurchaseIsLoading(false);
          return;
        }

        const receiptItems = JSON.parse(dataForSave.items).map(
          (purchaseItem, idx) => ({
            ...purchaseItem,
            salePrice: salePriceMap[idx] ?? purchaseItem.salePrice,
            batchNumber:
              batchNumberMap[idx] ??
              purchaseItem.batchNumber ??
              generateDefaultBatch(purchaseItem, values),
            isChecked: true,
            receivedQty: Number(purchaseItem.quantity) || 0,
            hasVariants: purchaseItem.hasVariants || false,
            variantType: purchaseItem.variantType || "size",
            variantConfig: purchaseItem.variantConfig || {
              color: [],
              size: [],
              model: [],
              custom: [],
            },
            variants: purchaseItem.variants || [],
          }),
        );
        payload = {
          ...dataForSave,
          items: JSON.stringify(receiptItems),
          orderStatus: "received",
        };
      }

      const result = await updatePurchase(finalBusinessUuid, buyUuid, payload);
      setPurchaseIsLoading(false);

      if (result.status === 200) {
        toast.success("Updated SuccessFully!");
        await updateBuy(result.data);

        if (promotedFromDraft) {
          toast.success(
            values.orderStatus === "partial_received"
              ? "Purchase saved. Enter the delivered quantities."
              : "Purchase saved. Confirm received quantities.",
          );
          navigateToPurchaseReceipt(buyUuid);
          close();
          return;
        }

        if (receiptChoice === "partialDelivery") {
          toast.success("Purchase saved. Enter the delivered quantities.");
          navigateToPurchaseReceipt(buyUuid);
          close();
          return;
        }

        navigate(-1);
        close(true);
      } else {
        throw new Error(result?.data?.message || "Update failed");
      }
    } else {
      setPurchaseIsLoading(true);
      const result = await createBuy(finalBusinessUuid, dataForSave);

      if (result.status === 201) {
        if (typeof addBuy === "function") {
          addBuy(result.data);
        }

        resetForm?.();
        const buyUuid = result.data?.buyUuid;

        if (receiptChoice === "receiveNow") {
          try {
            if (!buyUuid) {
              throw new Error("Purchase was saved without a purchase ID.");
            }

            //  block inventory update on variant/qty mismatch
            const badVariant = productSections.find((s) => {
              const hasVar =
                s.hasVariants &&
                Array.isArray(s.variants) &&
                s.variants.length > 0;
              if (!hasVar) return false;
              return totalVariantQuantityForSection(s) !== Number(s.quantity);
            });
            if (badVariant) {
              throw new Error(
                `"${badVariant.productName || "Item"}": variant quantities must match purchase quantity before adding to inventory.`,
              );
            }

            const receiptItems = JSON.parse(dataForSave.items).map(
              (purchaseItem, idx) => ({
                ...purchaseItem,
                salePrice: salePriceMap[idx] ?? purchaseItem.salePrice,
                batchNumber:
                  batchNumberMap[idx] ??
                  purchaseItem.batchNumber ??
                  generateDefaultBatch(purchaseItem, values),
                isChecked: true,
                receivedQty: Number(purchaseItem.quantity) || 0,
                hasVariants: purchaseItem.hasVariants || false,
                variantType: purchaseItem.variantType || "size",
                variantConfig: purchaseItem.variantConfig || {
                  color: [],
                  size: [],
                  model: [],
                  custom: [],
                },
                variants: purchaseItem.variants || [],
              }),
            );

            const receiptResult = await updatePurchase(
              finalBusinessUuid,
              buyUuid,
              {
                ...dataForSave,
                items: JSON.stringify(receiptItems),
                orderStatus: "received",
              },
            );

            if (receiptResult?.status !== 200) {
              throw new Error("Inventory receipt could not be completed.");
            }

            toast.success(
              isRawMaterials
                ? "Purchase added to warehouse."
                : "Purchase added to inventory.",
            );
            setPurchaseIsLoading(false);
            navigate(-1);
            close();
            return;
          } catch (receiptError) {
            console.error("Error receiving purchased items:", receiptError);
            toast.error(
              "Purchase saved, but the inventory update failed. Please complete the receipt manually.",
            );
            setPurchaseIsLoading(false);
            if (buyUuid) {
              navigateToPurchaseReceipt(buyUuid);
            } else {
              navigate(-1);
            }
            close();
            return;
          }
        }

       setPurchaseIsLoading(false);
if (receiptChoice === "partialDelivery" && buyUuid) {
  toast.success("Purchase saved. Enter the delivered quantities.");
  try {
    await dispatch(getBuysData(finalBusinessUuid));
  } catch (e) {
  }
  navigateToPurchaseReceipt(buyUuid);
} else {
  toast.success("Successfully Submitted");
  navigate(-1);
}
close();
      } else {
        setPurchaseIsLoading(false);
        throw new Error(result?.data?.message || "Creation failed");
      }
    }
  } catch (error) {
    setPurchaseIsLoading(false);
    toast.error(error.message);
    console.error("Error:", error);
  }
};

  const navigateToPurchaseReceipt = (buyUuid) => {
    if (isRawMaterials) {
      navigate(`/${finalBusinessUuid}/dashboard/Addwarehouseproduct`, {
        state: { buyUuid, isOpen: true },
      });
      return;
    }

    navigate(`/${finalBusinessUuid}/dashboard/purchase/${buyUuid}/products`);
  };

const handleReceiptChoice = async (
  choice,
  prices = {},
  batches = {},
) => {
  const values = pendingPurchaseValues || pendingUpdateValues;
  const isUpdate = !!pendingUpdateValues;

  setShowReceiptOptions(false);
  setAskSalePrice(false);
  setPendingPurchaseValues(null);
  setPendingUpdateValues(null);
  setBatchNumbers({});

  if (!values) return;

  if (isUpdate) {
    // Partial delivery in update mode → just navigate to receipt page
    if (choice === "partialDelivery") {
      await onSubmit(values, undefined, "partialDelivery");
    } else {
      await onSubmit(values, undefined, choice, prices, batches);
    }
  } else {
    await onSubmit(values, undefined, choice, prices, batches);
  }
};

const startReceiveNow = () => {
  const initialPrices = {};
  const initialBatches = {};
  const valuesForBatch = pendingPurchaseValues || pendingUpdateValues;

  productSections.forEach((section, idx) => {
    // Prefill with purchase price per unit if no sale price set
    const purchaseUnit = getPurchasePricePerUnit(section);
    const existingSale = Number(section.salePrice) || 0;
    initialPrices[idx] =
      existingSale > 0
        ? section.salePrice
        : purchaseUnit > 0
          ? Math.ceil(purchaseUnit).toString()
          : "";

    initialBatches[idx] =
      section.batchNumber ||
      generateDefaultBatch(section, valuesForBatch);
  });

  setSalePrices(initialPrices);
  setBatchNumbers(initialBatches);
  setAskSalePrice(true);
};

const handleConfirmSalePrices = () => {
  // 1. Sale price check — point to the exact item
  const missingSale = productSections.findIndex(
    (_, idx) => !(Number(salePrices[idx]) > 0),
  );
  if (missingSale !== -1) {
    toast.error(
      `Please enter a sale price for "${productSections[missingSale].productName || `Item ${missingSale + 1}`}".`,
    );
    return;
  }

  // 2. Batch number check — point to the exact item
  const missingBatch = productSections.findIndex(
    (_, idx) => !String(batchNumbers[idx] || "").trim(),
  );
  if (missingBatch !== -1) {
    toast.error(
      `Please enter a batch number for "${productSections[missingBatch].productName || `Item ${missingBatch + 1}`}".`,
    );
    return;
  }

  // 3. Variant quantity match — only for items that actually have variants.
  //    If any item has variants, its variant quantities MUST equal the
  //    purchase quantity before we touch inventory.
  const variantMismatchIndex = productSections.findIndex((s) => {
    const hasVar =
      s.hasVariants && Array.isArray(s.variants) && s.variants.length > 0;
    if (!hasVar) return false;
    return totalVariantQuantityForSection(s) !== Number(s.quantity);
  });

  if (variantMismatchIndex !== -1) {
    const s = productSections[variantMismatchIndex];
    const varQty = totalVariantQuantityForSection(s);
    const orderedQty = Number(s.quantity) || 0;
    toast.error(
      `"${s.productName || `Item ${variantMismatchIndex + 1}`}": variant quantities (${varQty}) must equal purchase quantity (${orderedQty}). Click "Edit Variants" to fix.`,
      { autoClose: 6000 },
    );
    return;
  }

  handleReceiptChoice("receiveNow", salePrices, batchNumbers);
};



  const calculateFinalPrice = (index, sections) => {
    const section = sections[index];
    const purchasePrice = parseFloat(section.purchasePrice) || 0;
    const quantity = section.quantity || 0;

    const discount = visibleFields.discount
      ? parseFloat(section.discount) || 0
      : 0;
    const discountUnit = visibleFields.discount ? section.discountUnit : null;
    const igst = visibleFields.hsn ? parseFloat(section.igst) || 0 : 0;
    const cgst = visibleFields.hsn ? parseFloat(section.cgst) || 0 : 0;
    const sgst = visibleFields.hsn ? parseFloat(section.sgst) || 0 : 0;
    const cess = visibleFields.hsn ? parseFloat(section.cess) || 0 : 0;

    const otherFee = visibleFields.otherFee
      ? parseFloat(section.otherFee) || 0
      : 0;

    const taxPercentage = intraState ? igst + cess : cgst + sgst + cess;

    let discountedPrice = purchasePrice;
    if (discountUnit === "₹") {
      discountedPrice = Math.max(purchasePrice - discount, 0);
    } else if (discountUnit === "%") {
      discountedPrice = purchasePrice - (purchasePrice * discount) / 100;
    }

    const priceWithTax =
      discountedPrice + (purchasePrice * taxPercentage) / 100;
    let finalPrice = priceWithTax * quantity;

    finalPrice += otherFee;

    sections[index] = {
      ...section,
      finalPrice: finalPrice.toFixed(2),
      costPerUnit: Math.ceil(finalPrice / quantity),
    };
  };

  const handleInputChange = (index, field, value) => {
    setProductSections((prevSections) => {
      const newSections = [...prevSections];
      newSections[index] = { ...newSections[index] };

      if (field === "discount") {
        newSections[index][field] = evaluateExpression(value);
      } else {
        newSections[index][field] = value;
      }

      // If quantity changes and product has variants, clear variants
      if (field === "quantity" && newSections[index].hasVariants) {
        newSections[index].hasVariants = false;
        newSections[index].variants = [];
        toast.info(
          "Quantity changed. Variants have been cleared. Please reconfigure variants.",
        );
      }

      if (
        field === "purchasePrice" ||
        field === "discount" ||
        field === "igst" ||
        field === "cgst" ||
        field === "sgst" ||
        field === "cess" ||
        field === "quantity" ||
        field === "otherFee" ||
        field === "discountUnit"
      ) {
        calculateFinalPrice(index, newSections);
      }

      return newSections;
    });
  };

  const handleToggleVisibleField = (fieldKey) => {
    if (!fieldKey === "hsn") return;
    if (fieldKey === "discount" && visibleFields.discount === true) {
      const newSections = productSections.map((section) => ({
        ...section,
        discount: "0",
      }));
      setProductSections(newSections);

      newSections.forEach((_, index) => {
        calculateFinalPrice(index, newSections);
      });
    }
    if (fieldKey === "hsn" && visibleFields.hsn === true) {
      const newSections = productSections.map((section) => ({
        ...section,
        igst: "0",
        cgst: "0",
        sgst: "0",
        cess: "0",
        hsnNumber: "",
      }));
      setProductSections(newSections);
      newSections.forEach((_, index) => {
        calculateFinalPrice(index, newSections);
      });
    }
    if (fieldKey === "otherFee" && visibleFields.otherFee === true) {
      const newSections = productSections.map((section) => ({
        ...section,
        otherFee: "0",
      }));
      setProductSections(newSections);
      newSections.forEach((_, index) => {
        calculateFinalPrice(index, newSections);
      });
    }
    setVisibleFields((prev) => ({
      ...prev,
      [fieldKey]: !prev[fieldKey],
    }));
  };

  const handleToggleAllFields = (e) => {
    const newValue = e.target.checked;
    const updatedFields = Object.fromEntries(
      Object.entries(visibleFields).map(([key]) => [key, newValue]),
    );
    setVisibleFields(updatedFields);
  };

  useEffect(() => {
    if (item) {
      return;
    }
    const updatedSections = productSections.map((_, index) => {
      const sectionCopy = [...productSections];
      calculateFinalPrice(index, sectionCopy);
      setProductSections(sectionCopy);
      return sectionCopy[index];
    });
  }, [visibleFields]);

const handleAddProductSection = () => {
  setProductSections((prevSections) => [
    ...prevSections,
    {
      productName: "",
      quantity: 1,
      purchasePrice: "",
      discount: "",
      igst: "0",
      finalPrice: "",
      productId: "",
      cgst: "0",
      sgst: "0",
      cess: "0",
      otherFee: "",
      costPerUnit: 0,
      hsnNumber: "",
      discountUnit: "%",
      mrp: "",
      openingStock: "",
      lowStock: "",
      ean: generateHexTimeId(),
      sku_number: generateEanId(),
      LRNumber: "",
      logisticName: "",
      logisticVehicle: "",
      // Variant fields
      hasVariants: false,
      variantType: "size",
      variantConfig: {
        color: ["Red", "Blue", "Green", "Black", "White"],
        size: ["S", "M", "L", "XL"],
        model: [],
        custom: [],
      },
      variants: [],
    },
  ]);
};

  const filtereSuppliers = (inputValue) => {
    const filtered = suppliers.filter((supplier) =>
      supplier?.supplierMobile?.toString().startsWith(inputValue),
    );
    setFilteredSuppliers(filtered);
  };

  const handleMobileInputChange = (phone, country, setFieldValue) => {
    if (phone.length >= 6) {
      filtereSuppliers(phone);
    } else {
      setFilteredSuppliers([]);
    }
    setFieldValue("supplierMobile", phone);
  };

  const findSuppliersNameByMobile = (mobileNumber) => {
    const customer = suppliers.find(
      (customer) => customer.supplierMobile === mobileNumber,
    );
    setDisableName(true);
    return customer ? customer : "";
  };

  const handleCustomerSelect = (mobile, setFieldValue) => {
    const purchaseRecord = findSuppliersNameByMobile(mobile);
    if (purchaseRecord) {
      setFieldValue("supplierMobile", mobile);
      setFieldValue("fullName", purchaseRecord.fullName);
      setFieldValue("gstNumber", purchaseRecord.gstIn);
      setFieldValue(
        "supplierType",
        purchaseRecord.supplierType || "registered",
      );
      setFieldValue("address", purchaseRecord.address);
      setFieldValue("country", purchaseRecord.country);
      setFieldValue("state", purchaseRecord.state);
      setFieldValue(
        "supplierType",
        purchaseRecord.supplierType || "registered",
      );

      const stateList = State.getStatesOfCountry(
        purchaseRecord.country || "IN",
      ).map((state) => ({
        label: state.name,
        value: state.isoCode,
      }));
      setStates(stateList);

      setFieldValue("city", purchaseRecord.city || "");
      setFieldValue(
        "supplierType",
        purchaseRecord.supplierType || "registered",
      );
      setFieldValue("pincode", purchaseRecord.pincode || "");
    }

    setFilteredSuppliers([]);
  };

const handleDeleteProductSection = (index) => {
  if (productSections.length > 1) {
    setProductSections((prevSections) => {
      const newSections = [...prevSections];
      newSections.splice(index, 1);
      return newSections;
    });

    // Reindex the expanded-additional-info set so it tracks the shifted rows
    setExpandedAdditionalInfo((prev) => {
      const next = new Set();
      prev.forEach((i) => {
        if (i < index) next.add(i);
        else if (i > index) next.add(i - 1);
      });
      return next;
    });
  } else {
    toast.error("At least one item must Remain");
  }
};

const handleAdditionalInfo = (index) => {
  setExpandedAdditionalInfo((prev) => {
    const next = new Set(prev);
    if (next.has(index)) next.delete(index);
    else next.add(index);
    return next;
  });
};

const isAdditionalInfoOpen = (index) => expandedAdditionalInfo.has(index);
const isExistingInventoryProduct = (section) =>
  Boolean(section?.productId);
  const handleSelectedProducts = (selectedProducts) => {
    let transformedProducts;
    if (isRawMaterials) {
      transformedProducts = selectedProducts.map((p) => ({
        productName: p.rawMaterialName,
        quantity: 1,
        purchasePrice: p.purchasePrice,
        igst: p.igst || 0,
        cgst: p.cgst || 0,
        sgst: p.sgst_utgst || 0,
        cess: p.cess || 0,
        hsnNumber: p.hsnNumber || "",
        productId: p.rawMaterialId,
        ean: p.ean || generateHexTimeId(),
        sku_number: p.sku_number || generateEanId(),
        // Variant fields
        hasVariants: false,
        variantType: "size",
        variantConfig: {
          color: ["Red", "Blue", "Green", "Black", "White"],
          size: ["S", "M", "L", "XL"],
          model: [],
          custom: [],
        },
        variants: [],
      }));
    } else {
      transformedProducts = transformProducts(
        selectedProducts,
        isServices === true ? true : false,
      );
    }

    let updatedProducts = [];
    if (!productSections[0].productName) {
      updatedProducts = [...transformedProducts];
    } else {
      updatedProducts = [...productSections, ...transformedProducts];
    }
    setProductSections(updatedProducts);
    const startIndex = updatedProducts.length - transformedProducts.length;

    for (let i = startIndex; i < updatedProducts.length; i++) {
      calculateFinalPrice(i, updatedProducts);
    }
  };

  const handleAdditionalInfoChange = (index, field, value) => {
    const updatedSections = [...productSections];
    updatedSections[index] = {
      ...updatedSections[index],
      [field]: value,
    };
    setProductSections(updatedSections);
  };

  let formikRef = useRef(null);

  useEffect(() => {
    const formik = formikRef.current;
    if (!formik) return;
    if (!item || !Array.isArray(item.items)) return;
    const firstItem = item.items[0];
    if (firstItem?.LRNumber) {
      formik.setFieldValue("LRNumber", firstItem.LRNumber);
    }
    if (firstItem?.logisticName) {
      formik.setFieldValue("logisticName", firstItem.logisticName);
    }
    if (firstItem?.logisticVehicle) {
      formik.setFieldValue("logisticVehicle", firstItem.logisticVehicle);
    }
  }, [item]);

  const handleCommonChange = (field, value) => {
    setProductSections((prevSections) =>
      prevSections.map((section) => ({
        ...section,
        [field]: value,
      })),
    );
  };

  const extractStateName = (stj = "") => {
    const match = stj.match(/State - ([^,]+)/);
    return match ? match[1].trim() : "";
  };

  const verifyGST = async (gstNo, setFieldValue) => {
    try {
      const res = await verifyGSTService(gstNo);
      const gstData = res?.data?.data.data;
      if (!gstData) return;
      setFieldValue("address", gstData?.pradr?.adr || "");
      const stateName = extractStateName(gstData?.stj);
      const stateCode = STATE_CODE_MAP[stateName];
      if (stateCode) {
        setFieldValue("state", stateCode);
      }
    } catch (err) {
      console.error("GST Verify Error:", err);
    }
  };

  return (
    <>
      <TourGuide steps={BuySteps} runTour={runTour} />
      <Formik
        innerRef={formikRef}
        initialValues={{
          ...initialValuesForPurchase(item ? item : null, user),
          ...initialValues,
        }}
        validationSchema={purchaseValidationSchema}
      >
        {(formik) => {
          const {
            errors,
            values,
            touched,
            handleBlur,
            handleChange,
            setFieldValue,
          } = formik;

          const handlechangeForOrderStatus = (e) => {
            handleChange(e);
            if (e.target.value !== "ordered") {
              setFieldValue("transactionStatus", "paid");
            }
            if (e.target.value === "ordered") {
              setFieldValue("transactionStatus", "not_paid");
            }
          };

          const removeDiscount = (index) => {
            const updated = [...values.additionalDiscount];
            updated.splice(index, 1);
            setFieldValue("additionalDiscount", updated);
          };

          const addDiscount = () => {
            setFieldValue("additionalDiscount", [
              ...values.additionalDiscount,
              { label: "Discount", amount: 0, type: "%" },
            ]);
          };

          const removeFee = (index) => {
            const updated = [...values.additionalFee];
            updated.splice(index, 1);
            setFieldValue("additionalFee", updated);
          };

          const addFee = () => {
            setFieldValue("additionalFee", [
              ...values.additionalFee,
              { label: "Fee", amount: 0, type: "%" },
            ]);
          };

          return (
            <Form>
              <div className="space-y-2">
                <div className="bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
                  <div className="bg-gray-50 border dark:bg-gray-900 border-gray-200 dark:border-gray-700 dark:border-gray-700 rounded-lg p-3 dark:bg-[#170f2a] shadow-sm">
                    <div className="sticky top-0 z-[1] flex justify-between bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-700 py-3">
                      <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className="flex items-center justify-center w-11 h-11 mb-3 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-slate-800 hover:bg-blue-50 dark:hover:bg-slate-700 transition-all shadow-sm"
                      >
                        <FiArrowLeft className="text-xl text-gray-700 dark:text-white" />
                      </button>
                      {/* <button
                        type="button"
                        onClick={() => setShowInvoiceUploader(true)}
                        className="flex items-center gap-2 px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors text-sm shadow-sm hover:shadow-md"
                        disabled={
                          item &&
                          (item.orderStatus === "approved" ||
                            item.orderStatus === "received")
                        }
                      >
                        <FiUpload className="w-4 h-4" />
                        <span>Upload Invoice</span>
                      </button> */}
                    </div>
                    {/* Header */}
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center gap-2">
                        <div className="p-1 bg-gradient-to-br from-purple-100 to-purple-50 dark:from-purple-900/30 dark:to-purple-800/30 rounded">
                          <FiPercent className="text-purple-600 dark:text-purple-400 text-sm" />
                        </div>
                        <h3 className="text-sm font-semibold text-gray-900 dark:text-white">
                          Tax Settings
                        </h3>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
                      {/* Left: Tax Options with Checkboxes */}
                      <div className="bg-white dark:bg-gray-800 p-2.5 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
                        <div className="flex items-center gap-1.5 mb-2.5">
                          <div className="p-1 bg-gradient-to-br from-blue-100 to-blue-50 dark:from-blue-900/30 dark:to-blue-800/30 rounded">
                            <FiCheckCircle className="text-blue-600 dark:text-blue-400 text-sm" />
                          </div>
                          <h3 className="text-xs font-semibold text-gray-900 dark:text-white">
                            Tax Options
                          </h3>
                        </div>

                        <div className="space-y-1.5">
                          {/* ITC Checkbox */}
                          {showItc && (<label className="flex items-center gap-2 p-1.5 hover:bg-gray-50 dark:hover:bg-gray-900 rounded cursor-pointer">
                            <div className="relative">
                              <input
                                type="checkbox"
                                checked={itc}
                                onChange={() => setItc(!itc)}
                                className="sr-only"
                              />
                              <div
                                className={`w-3.5 h-3.5 border rounded flex items-center justify-center transition-all ${
                                  itc
                                    ? "bg-blue-600 border-blue-600 dark:bg-blue-500 dark:border-blue-500"
                                    : "border-gray-300 dark:border-gray-600"
                                }`}
                              >
                                {itc && (
                                  <FiCheck className="text-white text-xs" />
                                )}
                              </div>
                            </div>
                            <span className="text-xs font-medium text-gray-700 dark:text-gray-300">
                              ITC
                            </span>
                            <span className="text-xs text-gray-500 dark:text-gray-400 ml-auto">
                              Input Tax
                            </span>
                          </label>)}

                          {/* RCM Checkbox */}
                          {showRcm && (<label className="flex items-center gap-2 p-1.5 hover:bg-gray-50 dark:hover:bg-gray-900 rounded cursor-pointer">
                            <div className="relative">
                              <input
                                type="checkbox"
                                checked={rcm}
                                onChange={() => setRcm(!rcm)}
                                className="sr-only"
                              />
                              <div
                                className={`w-3.5 h-3.5 border rounded flex items-center justify-center transition-all ${
                                  rcm
                                    ? "bg-blue-600 border-blue-600 dark:bg-blue-500 dark:border-blue-500"
                                    : "border-gray-300 dark:border-gray-600"
                                }`}
                              >
                                {rcm && (
                                  <FiCheck className="text-white text-xs" />
                                )}
                              </div>
                            </div>
                            <span className="text-xs font-medium text-gray-700 dark:text-gray-300">
                              RCM
                            </span>
                            <span className="text-xs text-gray-500 dark:text-gray-400 ml-auto">
                              Reverse Charge
                            </span>
                          </label>)}

                          {/* Import Checkbox */}
                          {showImport && (<label className="flex items-center gap-2 p-1.5 hover:bg-gray-50 dark:hover:bg-gray-900 rounded cursor-pointer">
                            <div className="relative">
                              <input
                                type="checkbox"
                                checked={importPurchaseGoods}
                                onChange={() =>
                                  setImportPurchase(!importPurchaseGoods)
                                }
                                className="sr-only"
                              />
                              <div
                                className={`w-3.5 h-3.5 border rounded flex items-center justify-center transition-all ${
                                  importPurchaseGoods
                                    ? "bg-blue-600 border-blue-600 dark:bg-blue-500 dark:border-blue-500"
                                    : "border-gray-300 dark:border-gray-600"
                                }`}
                              >
                                {importPurchaseGoods && (
                                  <FiCheck className="text-white text-xs" />
                                )}
                              </div>
                            </div>
                            <span className="text-xs font-medium text-gray-700 dark:text-gray-300">
                              Import
                            </span>
                            <span className="text-xs text-gray-500 dark:text-gray-400 ml-auto">
                              Import Goods
                            </span>
                          </label>)}
                        </div>
                      </div>

                      {/* Right: GST & Transaction */}
                      <div className="bg-white dark:bg-gray-800 p-2.5 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
                        <div className="flex items-center gap-1.5 mb-2.5">
                          <div className="p-1 bg-gradient-to-br from-green-100 to-green-50 dark:from-green-900/30 dark:to-green-800/30 rounded">
                            <FiMap className="text-green-600 dark:text-green-400 text-sm" />
                          </div>
                          <h3 className="text-xs font-semibold text-gray-900 dark:text-white">
                            GST & Location
                          </h3>
                        </div>

                        <div className="space-y-2.5">
                          {/* GST Input Compact */}
                          <div>
                            <div className="flex items-center justify-between mb-1">
                              <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
                                GST Number
                              </label>
                              <span className="text-xs text-gray-500">
                                {values.gstNumber?.length || 0}/15
                              </span>
                            </div>
                            <div className="flex gap-1.5">
                              <div className="flex-1">
                                <CustomField
                                  type="text"
                                  name="gstNumber"
                                  placeholder="Enter GSTIN"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.gstNumber}
                                  touched={touched.gstNumber}
                                  className="w-full text-xs py-1.5 px-2 h-8"
                                  size="small"
                                  inputProps={{ maxLength: 15 }}
                                />
                              </div>
                              <button
                                type="button"
                                onClick={() => {
                                  verifyGST(values.gstNumber, setFieldValue);
                                }}
                                disabled={values.gstNumber?.length !== 15}
                                className={`px-2.5 h-8 rounded text-xs font-medium whitespace-nowrap transition-colors ${
                                  values.gstNumber?.length === 15
                                    ? "bg-blue-600 hover:bg-blue-700 text-white"
                                    : "bg-gray-100 dark:bg-gray-700 text-gray-400 cursor-not-allowed"
                                }`}
                              >
                                Verify
                              </button>
                            </div>
                          </div>

                          {/* Transaction Type - Proper Toggle */}
                          <div className="pt-2 border-t border-gray-100 dark:border-gray-700">
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-2">
                                <div className="p-1 bg-gradient-to-br from-indigo-100 to-indigo-50 dark:from-indigo-900/30 dark:to-indigo-800/30 rounded">
                                  <FiNavigation className="text-indigo-600 dark:text-indigo-400 text-xs" />
                                </div>
                                <div>
                                  <span className="text-xs font-medium text-gray-700 dark:text-gray-300 block">
                                    Transaction Type
                                  </span>
                                  <span className="text-xs text-gray-500 dark:text-gray-400">
                                    {intraState
                                      ? "Within State"
                                      : "Between States"}
                                  </span>
                                </div>
                              </div>

                              {/* Fixed Toggle Button - Gray when OFF, Green when ON */}
                              <div className="flex items-center">
                                <span
                                  className={`text-xs font-medium mr-2 transition-colors ${
                                    !intraState
                                      ? "text-gray-700 dark:text-gray-300"
                                      : "text-gray-500"
                                  }`}
                                >
                                  Interstate
                                </span>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleToggleIntraState(!intraState)
                                  }
                                  className={`relative w-11 h-6 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 transition-colors ${
                                    intraState
                                      ? "bg-green-500 hover:bg-green-600"
                                      : "bg-gray-300 hover:bg-gray-400 dark:bg-gray-600"
                                  }`}
                                >
                                  <span
                                    className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow transform transition-transform ${
                                      intraState
                                        ? "translate-x-5"
                                        : "translate-x-0"
                                    }`}
                                  />
                                </button>
                                <span
                                  className={`text-xs font-medium ml-2 transition-colors ${
                                    intraState
                                      ? "text-gray-700 dark:text-gray-300"
                                      : "text-gray-500"
                                  }`}
                                >
                                  Intrastate
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <>
                    <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-4 mb-6 bg-gray-50 dark:bg-[#170f2a] shadow-sm">
                      <div className="flex items-center justify-between mb-4">
                        {/* Left side - Icon and text */}
                        <div className="flex items-center gap-3">
                          <div className="p-2 bg-gradient-to-br from-orange-50 to-orange-50 dark:from-orange-900/20 dark:to-orange-900/20 rounded-xl">
                            <svg
                              className="w-5 h-5 text-orange-600 dark:text-blue-400"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                              />
                            </svg>
                          </div>
                          <div>
                            <p className="text-sm text-blue-700 font-semibold dark:text-gray-400">
                              Enter Supplier details and preferences
                            </p>
                          </div>
                        </div>

                        {/* Right side - More Fields button */}
                        <div className="flex items-center">
                          <button
                            type="button"
                            onClick={() =>
                              setShowAdditionalFields(!showAdditionalFields)
                            }
                            className={`
                              relative
                              px-3 py-1.5
                              bg-blue-50 hover:bg-blue-100
                              dark:bg-gray-700 dark:hover:bg-gray-600
                              text-blue-600 dark:text-blue-400
                              hover:text-blue-800 dark:hover:text-blue-300
                              rounded-lg
                              border border-blue-200 dark:border-gray-600
                              transition-all duration-200
                              flex items-center justify-center
                              group
                              text-sm
                              shadow-sm hover:shadow-md
                            `}
                          >
                            {showAdditionalFields ? (
                              <>
                                <FiChevronUp className="mr-1 transition-transform duration-200" />
                                <span>Hide Fields</span>
                              </>
                            ) : (
                              <>
                                <FiChevronDown className="mr-1 transition-transform duration-200" />
                                <span>More Fields</span>
                              </>
                            )}
                            <span
                              className={`
                                absolute -bottom-1 left-0 right-0
                                h-0.3 bg-blue-200 dark:bg-blue-800
                                transition-all duration-300
                                ${showAdditionalFields ? "scale-x-100" : "scale-x-0"}
                              `}
                            ></span>
                          </button>
                        </div>
                      </div>

                      <div className="grid grid-cols-4 gap-4 bg-white p-4 mb-6 mt-4 rounded-lg dark:bg-[#020617]">
                        <div className="col-span-1 relative">
                          <CustomPhoneNumberField
                            name="supplierMobile"
                            countryCode={values.countryCode}
                            label={t("FORM.SUPPLIER_NUMBER")}
                            value={values.supplierMobile}
                            onBlur={handleBlur}
                            error={errors.supplierMobile}
                            touched={touched.supplierMobile}
                            handleInputChange={(
                              phone,
                              country,
                              setFieldValue,
                            ) => {
                              if (
                                item &&
                                (values.orderStatus === "approved" ||
                                  values.orderStatus === "received")
                              )
                                return;
                              handleMobileInputChange(
                                phone,
                                country,
                                setFieldValue,
                              );
                            }}
                            disabled={
                              item &&
                              (values.orderStatus === "approved" ||
                                values.orderStatus === "received")
                            }
                            required={true}
                          />

                          {filteredSuppliers.length > 0 && (
                            <div className="absolute bg-white border border-gray-300 mt-1 py-1 rounded w-full z-10 shadow-lg dark:border-gray-500 dark:bg-gray-800">
                              {filteredSuppliers.map((suppliers, index) => (
                                <div
                                  key={suppliers.supplierMobile}
                                  onClick={() =>
                                    handleCustomerSelect(
                                      suppliers.supplierMobile,
                                      setFieldValue,
                                    )
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      handleCustomerSelect(
                                        suppliers.supplierMobile,
                                        setFieldValue,
                                      );
                                    }
                                  }}
                                  tabIndex={0}
                                  role="button"
                                  className={`px-3 py-1 cursor-pointer hover:bg-blue-100 dark:hover:bg-gray-900 ${
                                    index === 0 ? "rounded-t" : ""
                                  } ${
                                    index === filteredSuppliers.length - 1
                                      ? "rounded-b"
                                      : ""
                                  }`}
                                >
                                  {suppliers.supplierMobile}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        <div className="col-span-1">
                          <CustomField
                            type="text"
                            name="fullName"
                            label={t("FORM.SUPPLIER_NAME")}
                            placeholder="Supplier Name"
                            onChange={
                              item &&
                              (values.orderStatus === "approved" ||
                                values.orderStatus === "received")
                                ? () => {}
                                : handleChange
                            }
                            value={values.fullName}
                            onBlur={handleBlur}
                            error={errors.fullName}
                            touched={touched.fullName}
                            disabled={
                              item &&
                              (values.orderStatus === "approved" ||
                                values.orderStatus === "received")
                            }
                            required={true}
                          />

                          {/* Show validation error if field is empty and form is touched */}
                          {touched.fullName && !values.fullName && (
                            <span className="text-red-500 text-xs mt-1 block">
                              Supplier name is required
                            </span>
                          )}
                        </div>

                        <div className="col-span-1">
                          <CustomField
                            type="select"
                            name="supplierType"
                            placeholder="Supplier type"
                            label={t("FORM.SUPPLIER_TYPE")}
                            handleChange={handleChange}
                            setFieldValue={setFieldValue}
                            options={optionsForSupplierType}
                            value={values.supplierType}
                            disabled={item}
                          />
                        </div>

                        {/* Additional fields - conditionally rendered */}
                        {showAdditionalFields && (
                          <div className="col-span-4 grid grid-cols-3 gap-4 border-t border-gray-100 dark:border-gray-700 pt-4 mt-2">
                            <div className="col-span-1">
                              <CustomField
                                type="text"
                                name="address"
                                label={t("FORM.ADDRESS")}
                                placeholder="Address"
                                handleChange={handleChange}
                                value={values.address}
                              />
                            </div>

                            <div className="col-span-1">
                              <CustomField
                                type="select"
                                name="country"
                                label={t("FORM.COUNTRY")}
                                options={countries}
                                setFieldValue={setFieldValue}
                                handleChange={(e) =>
                                  handleCountryChange(
                                    setFieldValue,
                                    e?.target?.value,
                                  )
                                }
                                value={values.country}
                              />
                            </div>

                            <div className="col-span-1">
                              <CustomField
                                type="select"
                                name="state"
                                label={t("FORM.SATAE")}
                                placeholder="State"
                                handleChange={(e) => {
                                  setFieldValue("state", e?.target?.value);
                                }}
                                options={states}
                                setFieldValue={setFieldValue}
                                value={values.state}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>

                  <div className="flex items-center justify-between mt-2 mb-4">
                    {/* Left side - Add Items with icon and microphone */}
                    <div className="flex items-center">
                      <div className="flex items-center">
                        <div className="p-2 bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-900/10 rounded-xl mr-3">
                          <svg
                            className="w-5 h-5 text-green-600 dark:text-green-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 4v16m8-8H4"
                            />
                          </svg>
                        </div>
                        <p className="text-sm text-green-700 font-semibold dark:text-green-400 mr-3">
                          Add Items
                        </p>
                        {/* Microphone indicator with tooltip */}
                        <div className="relative group">
                          <div className="flex items-center gap-2 px-3 py-1.5 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
                            <div
                              className={`relative ${isMicActive ? "animate-pulse" : ""}`}
                            >
                              <HiOutlineMicrophone
                                size={18}
                                className={`${isMicActive ? "text-green-600 dark:text-green-400" : "text-blue-600 dark:text-blue-400"}`}
                              />
                              {isMicActive && (
                                <div className="absolute -top-1 -right-1 w-2 h-2 bg-green-500 rounded-full animate-ping"></div>
                              )}
                            </div>
                            <span className="text-xs font-medium text-blue-700 dark:text-blue-300">
                              Voice Input
                            </span>
                            <div className="text-xs px-1.5 py-0.5 bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-300 rounded-full">
                              Active
                            </div>
                          </div>

                          {/* Tooltip */}
                          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 dark:bg-gray-700 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50 pointer-events-none">
                            Double-click any input field to activate voice input
                            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-2 h-2 bg-gray-900 dark:bg-gray-700 rotate-45"></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Right side - Everything aligned to the far right */}
                    <div className="flex items-center space-x-4">
                      {/* Product Type checkboxes */}
                      <div className="flex items-center space-x-4 bg-white dark:bg-gray-800/50 dark:bg-[#020617]">
                        <FormControlLabel
                          control={
                            <Field
                              as={Checkbox}
                              name="isProducts"
                              checked={isProducts}
                              onChange={() => handleIsProduct(isProducts)}
                              className="dark:text-white dark:checked:bg-white"
                              disabled={values.orderStatus === "received"}
                            />
                          }
                          label={
                            <span className="text-sm text-blue-700 dark:text-white">
                              {t("CARD.PRODUCTS")}
                            </span>
                          }
                        />

                        {/* <FormControlLabel
                          control={
                            <Field
                              as={Checkbox}
                              name="isServices"
                              checked={isServices}
                              onChange={() => handleIsService(isServices)}
                              className="dark:text-white dark:checked:bg-white"
                              disabled={values.orderStatus === "received"}
                            />
                          }
                          label={
                            <span className="text-sm text-blue-700 dark:text-white">
                              {t("FORM.SERVICES")}
                            </span>
                          }
                        /> */}

                        <FormControlLabel
                          control={
                            <Field
                              as={Checkbox}
                              name="isRawMaterials"
                              checked={isRawMaterials}
                              onChange={() =>
                                handleIsRawMaterial(isRawMaterials)
                              }
                              className="dark:text-white dark:checked:bg-white"
                              disabled={values.orderStatus === "received"}
                            />
                          }
                          label={
                            <span className="text-sm text-blue-700 dark:text-white">
                              {t("FORM.RAW_MATERIALS")}
                            </span>
                          }
                        />
                      </div>

                      {/* Add Field Button */}
                      <div className="relative">
                        <button
                          type="button"
                          onClick={() => setShowFilter(!showFilter)}
                          className="flex items-center gap-2 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors text-sm shadow-sm hover:shadow-md"
                          title="Add Custom Fields"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <span>Add Fields</span>
                        </button>

                        {/* Field Selection Dropdown */}
                        {showFilter && (
                          <div className="absolute top-full right-0 mt-1 w-56 p-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl z-50">
                            <div className="flex justify-between items-center mb-2">
                              <h4 className="text-sm font-semibold text-gray-800 dark:text-white">
                                Available Fields
                              </h4>
                              <button
                                onClick={() => setShowFilter(false)}
                                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 text-sm"
                              >
                                ✖️
                              </button>
                            </div>

                            <div className="space-y-2">
                              <div className="flex items-center justify-between py-1">
                                <span className="text-xs font-medium text-gray-700 dark:text-gray-300">
                                  Select All
                                </span>
                                <input
                                  type="checkbox"
                                  checked={Object.values(visibleFields).every(
                                    Boolean,
                                  )}
                                  onChange={handleToggleAllFields}
                                  className="h-3.5 w-3.5 text-blue-600 rounded focus:ring-blue-500"
                                />
                              </div>

                              {/* Individual Fields */}
                              {Object.keys(visibleFields)
                                .filter((field) => !disabledPurchaseFields[field])
                                .map((field) => (
                                <div
                                  key={field}
                                  className="flex items-center justify-between py-1"
                                >
                                  <span className="text-xs text-gray-700 dark:text-gray-300 capitalize">
                                    {field === "hsn"
                                      ? "HSN/SAC"
                                      : field === "disUnit"
                                        ? "Discount Unit"
                                        : field === "otherFee"
                                          ? "Other Fee"
                                          : field}
                                  </span>
                                  <input
                                    type="checkbox"
                                    checked={visibleFields[field]}
                                    onChange={() =>
                                      handleToggleVisibleField(field)
                                    }
                                    className="h-3.5 w-3.5 text-blue-600 rounded focus:ring-blue-500"
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 bg-gray-50 dark:bg-[#020617]">
                    <div className="overflow-x-auto scroll-h-6 whitespace-nowrap">
                      <div className="min-w-[1200px] overflow-x-auto scroll-h-6">
                        {/* Table Header */}
                        <div className="grid grid-cols-12 bg-green-50 border-2 border-green-300 gap-1 dark:bg-gray-800 p-2 rounded-lg">
                          <div className="col-span-2">
                            <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                              {isServices
                                ? t("REPORT.SERVICE_NAME")
                                : t("REPORT.PRODUCT_NAME_EAN")}
                            </label>
                          </div>

                          <div className="col-span-1">
                            <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                              {t("FORM.QUANTITY")}
                            </label>
                          </div>

                          <div className="col-span-1">
                            <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                              {t("SIDEBAR.PURCHASE")}
                              <div className="text-xs text-gray-500 dark:text-gray-300">
                                {t("FORM.PRICE_PER_UNIT")}
                              </div>
                            </label>
                          </div>

                          <div className="col-span-1">
                            <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                              {t("REPORT.FINAL")}
                            </label>
                          </div>

                          <div className="col-span-7">
                            <div className="grid grid-cols-10 gap-1">
                              {visibleFields.discount && (
                                <div className="col-span-1">
                                  <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                    {t("FORM.DISCOUNT")}
                                  </label>
                                </div>
                              )}
                              {visibleFields.discount && (
                                <div className="col-span-1">
                                  <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                    DisUnit
                                  </label>
                                </div>
                              )}
                              {visibleFields.hsn && (
                                <div className="col-span-1">
                                  <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                    {t("FORM.HSN")}
                                  </label>
                                </div>
                              )}
                              {visibleFields.hsn && (
                                <div className="col-span-1">
                                  <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                    {t("TAX_WITHOUT_PERC.IGST")}
                                  </label>
                                </div>
                              )}
                              {visibleFields.hsn && (
                                <div className="col-span-1">
                                  <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                    {t("TAX_WITHOUT_PERC.CGST")}
                                  </label>
                                </div>
                              )}
                              {visibleFields.hsn && (
                                <div className="col-span-1">
                                  <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                    {t("TAX_WITHOUT_PERC.SGST")}
                                  </label>
                                </div>
                              )}
                              {visibleFields.hsn && (
                                <div className="col-span-1">
                                  <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                    {t("TAX_WITHOUT_PERC.CESS")}
                                  </label>
                                </div>
                              )}
                              {visibleFields.otherFee && (
                                <div className="col-span-1">
                                  <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                    {t("REPORT.OTHER_FEE")}
                                  </label>
                                </div>
                              )}
                              <div className="col-span-1">
                                <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                  Variants
                                </label>
                              </div>
                              <div className="col-span-1">
                                <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                  Actions
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Product Rows */}
                        <div className="space-y-7 mt-1">
                          {productSections.map((section, index) => (
                            <div
                              key={index}
                              className="grid grid-cols-12 gap-1 items-center py-4 px-1 bg-white dark:bg-[#170f2a] rounded-lg border border-gray-200 dark:border-gray-700"
                            >
                              {/* Product Name */}
                              <div className="col-span-2 relative">
                                <input
                                  type="text"
                                  id={`productName${index + 1}`}
                                  placeholder={
                                    isServices
                                      ? t("REPORT.SERVICE_NAME")
                                      : t("REPORT.PRODUCT_NAME_EAN")
                                  }
                                  className={`w-full py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm ${
                                    listeningproductIndex === index
                                      ? "bg-green-100 outline-green-600 outline-2 animate-pop-up"
                                      : ""
                                  }`}
                                  value={section.productName}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "productName",
                                      e.target.value,
                                    )
                                  }
                                  onBlur={handleBlur}
                                  onKeyUp={(e) => handleInputSearch(e, index)}
                                  onDoubleClick={() => handleVoiceSearch(index)}
                                  disabled={
                                    isMicActive ||
                                    values.orderStatus === "received" ||
                                    values.transactionStatus ===
                                      "partialy-paid" ||
                                    values.transactionStatus === "Advance"
                                  }
                                  data-tooltip-id={`tooltip-${index}`}
                                />
                                <button
                                  type="button"
                                  onClick={() => handleVoiceSearch(index)}
                                  className="absolute right-2 top-1.5 text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 text-sm"
                                  title="Search product by voice"
                                >
                                  <HiOutlineMicrophone
                                    className={`text-lg ${
                                      listeningproductIndex
                                        ? "text-green-500 animate-pulse"
                                        : ""
                                    }`}
                                  />
                                </button>
                                {!section.productName && (
                                  <span className="absolute -bottom-4 left-0 block text-red-500 text-xs">
                                    {isServices
                                      ? "Service Name is required."
                                      : "Product Name is required."}
                                  </span>
                                )}
                                {activeIndex === index &&
                                  listeningproductIndex && (
                                    <div className="absolute inset-0 bg-white bg-opacity-90 dark:bg-gray-800 dark:bg-opacity-90 flex items-center justify-center rounded">
                                      <span className="text-gray-800 dark:text-white font-medium text-xs">
                                        Listening...
                                      </span>
                                    </div>
                                  )}
                                {searchResults.length > 0 &&
                                  activeIndex === index && (
                                    <div className="absolute z-10 mt-1 w-full bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded shadow-lg max-h-60 overflow-auto text-sm">
                                      {searchResults.map((product, i) => (
                                        <div
                                          key={i}
                                          onClick={() =>
                                            handleSelectProduct(product, index)
                                          }
                                          className="px-2 py-1 hover:bg-blue-50 dark:hover:bg-gray-600 cursor-pointer"
                                        >
                                          {isRawMaterials
                                            ? product.rawMaterialName
                                            : product.productName ||
                                              product.serviceName}
                                          {product?.batchNumber && (
                                            <span className="text-xs text-gray-500 dark:text-gray-400 ml-1">
                                              Batch: {product.batchNumber}
                                            </span>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  )}
{!isServices && !isExistingInventoryProduct(section) && (
  <button
    type="button"
    className="absolute -bottom-8 left-0 flex items-center text-xs text-blue-600 dark:text-blue-400 underline"
    onClick={() => handleAdditionalInfo(index)}
  >
    Additional Info
    {isAdditionalInfoOpen(index) ? (
      <FaChevronUp className="ml-1 text-xs" />
    ) : (
      <FaChevronDown className="ml-1 text-xs" />
    )}
  </button>
)}
                              </div>

                              {/* Quantity */}
                              <div className="col-span-1 relative">
                                <input
                                  type="text"
                                  id={`quantity${index + 1}`}
                                  placeholder="Qty"
                                  className={`w-full py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm ${
                                    listeningQtyIndex === index
                                      ? "bg-green-100 outline-green-600 outline-2 animate-pop-up"
                                      : ""
                                  }`}
                                  value={section.quantity}
                                  onKeyPress={onlyNumber}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "quantity",
                                      e.target.value,
                                    )
                                  }
                                  onDoubleClick={() =>
                                    handleVoiceSearchForQuantity(index)
                                  }
                                  disabled={
                                    isMicActive ||
                                    values.orderStatus === "received" ||
                                    values.transactionStatus ===
                                      "partialy-paid" ||
                                    values.transactionStatus === "Advance"
                                  }
                                />
                              </div>

                              {/* Purchase Price */}
                              <div className="col-span-1 relative">
                                <input
                                  type="text"
                                  id={`purchasePrice${index + 1}`}
                                  placeholder="Price"
                                  className={`w-full py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm ${
                                    listeningIndex === index
                                      ? "bg-green-100 outline-green-600 outline-2 animate-pop-up"
                                      : ""
                                  }`}
                                  value={section.purchasePrice}
                                  onKeyPress={onlyNumberdesimal}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "purchasePrice",
                                      e.target.value,
                                    )
                                  }
                                  onDoubleClick={() =>
                                    handleVoiceSearchForPurchasePrice(index)
                                  }
                                  disabled={
                                    isMicActive ||
                                    values.orderStatus === "received" ||
                                    values.transactionStatus ===
                                      "partialy-paid" ||
                                    values.transactionStatus === "Advance"
                                  }
                                />
                                {!section.purchasePrice && (
                                  <span className="absolute -bottom-4 left-0 block text-red-500 text-xs">
                                    {t("FORM.PRICE_IS_REQUIRED")}
                                  </span>
                                )}
                              </div>

                              {/* Final Price */}
                              <div className="col-span-1">
                                <input
                                  type="text"
                                  id={`finalPrice${index + 1}`}
                                  placeholder="Final"
                                  className="w-full py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded bg-gray-100 dark:bg-gray-600 text-sm"
                                  value={section.finalPrice}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "finalPrice",
                                      e.target.value,
                                    )
                                  }
                                  onKeyPress={onlyNumberdesimal}
                                  disabled={
                                    values.orderStatus === "received" ||
                                    values.transactionStatus ===
                                      "partialy-paid" ||
                                    values.transactionStatus === "Advance"
                                  }
                                />
                              </div>

                              {/* Dynamic Fields - Now col-span-7 to match header */}
                              <div className="col-span-7">
                                <div className="grid grid-cols-10 gap-1 items-center">
                                  {visibleFields.discount && (
                                    <div className="col-span-1">
                                      <input
                                        type="text"
                                        id={`discount${index + 1}`}
                                        placeholder="Disc"
                                        className={`w-full py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm ${
                                          activeVoiceIndex === index
                                            ? "bg-green-100 outline-green-600 outline-2 animate-pop-up"
                                            : ""
                                        }`}
                                        value={section.discount}
                                        onKeyPress={onlyNumberWithExpression}
                                        onChange={(e) =>
                                          handleInputChange(
                                            index,
                                            "discount",
                                            e.target.value,
                                          )
                                        }
                                        onDoubleClick={() =>
                                          handleVoiceSearchForDiscount(index)
                                        }
                                        disabled={
                                          isMicActive ||
                                          values.orderStatus === "received" ||
                                          values.transactionStatus ===
                                            "partialy-paid" ||
                                          values.transactionStatus === "Advance"
                                        }
                                      />
                                    </div>
                                  )}
                                  {visibleFields.discount && (
                                    <div className="col-span-1">
                                      <select
                                        className="w-full py-1.5 px-1 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                        id={`discountUnit${index + 1}`}
                                        onChange={(e) =>
                                          handleInputChange(
                                            index,
                                            "discountUnit",
                                            e.target.value,
                                          )
                                        }
                                        value={section.discountUnit}
                                      >
                                        <option value="%">%</option>
                                        <option value="₹">₹</option>
                                      </select>
                                    </div>
                                  )}
                                  {visibleFields.hsn && (
                                    <div className="col-span-1">
                                      <AutoCompleteFieldForTaxDetails
                                        index={index}
                                        items={taxDetails}
                                        productSections={productSections}
                                        setProductSections={setProductSections}
                                        calculateFinalPrice={
                                          calculateFinalPrice
                                        }
                                      />
                                    </div>
                                  )}
                                  {visibleFields.hsn && (
                                    <div className="col-span-1">
                                      <input
                                        type="text"
                                        id={`igst${index + 1}`}
                                        placeholder="IGST"
                                        className={`w-full py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm ${
                                          listeningigstIndex === index
                                            ? "bg-green-100 outline-green-600 outline-2 animate-pop-up"
                                            : ""
                                        }`}
                                        value={section.igst}
                                        onKeyPress={onlyNumberdesimal}
                                        onChange={(e) =>
                                          handleInputChange(
                                            index,
                                            "igst",
                                            e.target.value,
                                          )
                                        }
                                        onDoubleClick={() =>
                                          handleVoiceSearchForigst(index)
                                        }
                                        disabled={
                                          isMicActive ||
                                          parseFloat(section?.cgst) > 0 ||
                                          parseFloat(section?.sgst) > 0 ||
                                          values.orderStatus === "received" ||
                                          values.transactionStatus ===
                                            "partialy-paid" ||
                                          values.transactionStatus === "Advance"
                                        }
                                        maxLength={
                                          (
                                            section.igst?.toString() || ""
                                          ).includes(".")
                                            ? 5
                                            : 3
                                        }
                                      />
                                    </div>
                                  )}
                                  {visibleFields.hsn && (
                                    <div className="col-span-1">
                                      <input
                                        type="text"
                                        id={`cgst${index + 1}`}
                                        placeholder="CGST"
                                        className={`w-full py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm ${
                                          listeningcgstIndex === index
                                            ? "bg-green-100 outline-green-600 outline-2 animate-pop-up"
                                            : ""
                                        }`}
                                        value={section.cgst}
                                        onKeyPress={onlyNumberdesimal}
                                        onChange={(e) =>
                                          handleInputChange(
                                            index,
                                            "cgst",
                                            e.target.value,
                                          )
                                        }
                                        onDoubleClick={() =>
                                          handleVoiceSearchForcgst(index)
                                        }
                                        disabled={
                                          isMicActive ||
                                          parseFloat(section?.igst) > 0 ||
                                          values.orderStatus === "received" ||
                                          values.transactionStatus ===
                                            "partialy-paid" ||
                                          values.transactionStatus === "Advance"
                                        }
                                        maxLength={
                                          (
                                            section.cgst?.toString() || ""
                                          ).includes(".")
                                            ? 5
                                            : 3
                                        }
                                      />
                                    </div>
                                  )}
                                  {visibleFields.hsn && (
                                    <div className="col-span-1">
                                      <input
                                        type="text"
                                        id={`sgst${index + 1}`}
                                        placeholder="SGST"
                                        className={`w-full py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm ${
                                          listeningsgstIndex === index
                                            ? "bg-green-100 outline-green-600 outline-2 animate-pop-up"
                                            : ""
                                        }`}
                                        value={section.sgst}
                                        onKeyPress={onlyNumberdesimal}
                                        onChange={(e) =>
                                          handleInputChange(
                                            index,
                                            "sgst",
                                            e.target.value,
                                          )
                                        }
                                        onDoubleClick={() =>
                                          handleVoiceSearchForsgst(index)
                                        }
                                        disabled={
                                          isMicActive ||
                                          parseFloat(section?.igst) > 0 ||
                                          values.orderStatus === "received" ||
                                          values.transactionStatus ===
                                            "partialy-paid" ||
                                          values.transactionStatus === "Advance"
                                        }
                                        maxLength={
                                          (
                                            section.sgst?.toString() || ""
                                          ).includes(".")
                                            ? 5
                                            : 3
                                        }
                                      />
                                    </div>
                                  )}
                                  {visibleFields.hsn && (
                                    <div className="col-span-1">
                                      <input
                                        type="text"
                                        id={`cess${index + 1}`}
                                        placeholder="CESS"
                                        className={`w-full py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm ${
                                          listeningcessIndex === index
                                            ? "bg-green-100 outline-green-600 outline-2 animate-pop-up"
                                            : ""
                                        }`}
                                        value={section.cess}
                                        onKeyPress={onlyNumberdesimal}
                                        onChange={(e) =>
                                          handleInputChange(
                                            index,
                                            "cess",
                                            e.target.value,
                                          )
                                        }
                                        onDoubleClick={() =>
                                          handleVoiceSearchForcess(index)
                                        }
                                        disabled={
                                          isMicActive ||
                                          values.orderStatus === "received" ||
                                          values.transactionStatus ===
                                            "partialy-paid" ||
                                          values.transactionStatus === "Advance"
                                        }
                                        maxLength={
                                          (
                                            section.cess?.toString() || ""
                                          ).includes(".")
                                            ? 5
                                            : 3
                                        }
                                      />
                                    </div>
                                  )}
                                  {visibleFields.otherFee && (
                                    <div className="col-span-1">
                                      <input
                                        type="text"
                                        id={`otherFee${index + 1}`}
                                        placeholder="Fee"
                                        className={`w-full py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm ${
                                          listeningSaleIndex === index
                                            ? "bg-green-100 outline-green-600 outline-2 animate-pop-up"
                                            : ""
                                        }`}
                                        value={section.otherFee}
                                        onKeyPress={onlyNumberdesimal}
                                        onChange={(e) =>
                                          handleInputChange(
                                            index,
                                            "otherFee",
                                            e.target.value,
                                          )
                                        }
                                        onDoubleClick={() =>
                                          handleVoiceSearchForSalePrice(index)
                                        }
                                        disabled={
                                          isMicActive ||
                                          values.orderStatus === "received" ||
                                          values.transactionStatus ===
                                            "partialy-paid" ||
                                          values.transactionStatus === "Advance"
                                        }
                                      />
                                    </div>
                                  )}

                                  {/* Variant Button - Always col-span-1 */}
                                  <div className="col-span-1 flex flex-col items-center justify-center">
                                    <button
                                      type="button"
                                      className={`w-full py-1.5 px-2 text-sm rounded-md ${
                                        section.hasVariants
                                          ? "bg-green-100 text-green-700 border border-green-200 hover:bg-green-200"
                                          : "bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100"
                                      }`}
                                      onClick={() => openVariantModal(index)}
                                      disabled={
                                        !section.productName ||
                                        !section.quantity ||
                                        section.quantity <= 0 ||
                                        values.orderStatus === "received"
                                      }
                                      title={
                                        !section.productName ||
                                        !section.quantity ||
                                        section.quantity <= 0
                                          ? "Please enter product name and quantity first"
                                          : section.hasVariants
                                            ? "Edit variants"
                                            : "Add variants"
                                      }
                                    >
                                      {section.hasVariants ? "Edit" : "Add"}
                                    </button>
                                    {/* {section.hasVariants && section.variants?.length > 0 && (
                <div className="text-[10px] text-green-600 mb-2 text-center">
                  {section.variants.length} var
                </div>
              )} */}
                                  </div>

                                  {/* Action Buttons - Always col-span-1 */}
                                  <div className="col-span-1 flex items-center justify-center gap-1">
                                    <button
                                      type="button"
                                      onClick={handleAddProductSection}
                                      className="p-1.5 text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-gray-700 rounded-full transition-colors"
                                      title="Add More Rows"
                                      disabled={
                                        values.orderStatus === "received"
                                      }
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-4 w-4"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleDeleteProductSection(index)
                                      }
                                      className="p-1.5 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-gray-700 rounded-full transition-colors"
                                      title="Remove Row"
                                      disabled={
                                        values.orderStatus === "received"
                                      }
                                    >
                                      <BsTrash className="h-4 w-4" />
                                    </button>
                                  </div>
                                </div>
                              </div>

                              {/* Additional Info Section - Now full width below */}
                             {isAdditionalInfoOpen(index) && (
  <div className="col-span-12 mt-4 border-2 p-3 bg-gray-50 dark:bg-[#170f2a] dark:border-gray-600 rounded-lg">
    <div className="grid grid-cols-3 gap-4 bg-white  dark:bg-[#020617] rounded-lg p-2">
      <div>
        <CustomField
          type="text"
          name={`productSections[${index}].productCategory`}
          label={t("FORM.PURCHASE_CATEGORY")}
          placeholder="Product Category"
          handleChange={(e) =>
            handleAdditionalInfoChange(index, "productCategory", e.target.value)
          }
          value={productSections[index]?.productCategory || ""}
        />
      </div>
      <div>
        <CustomField
          type="text"
          name={`productSections[${index}].productSubCategory`}
          label={t("FORM.PURCHASE_SUB_CATEGORY")}
          placeholder="Product Sub Category"
          handleChange={(e) =>
            handleAdditionalInfoChange(
              index,
              "productSubCategory",
              e.target.value,
            )
          }
          value={productSections[index]?.productSubCategory || ""}
        />
      </div>
      <div>
        <CustomField
          type="text"
          name={`productSections[${index}].brandName`}
          label={t("FORM.BRAND_NAME")}
          placeholder="Brand Name"
          handleChange={(e) =>
            handleAdditionalInfoChange(index, "brandName", e.target.value)
          }
          value={productSections[index]?.brandName || ""}
        />
      </div>
      <div>
        <CustomField
          type="text"
          name={`productSections[${index}].ean`}
          label={t("FORM.EAN")}
          placeholder="EAN number"
          handleChange={(e) =>
            handleAdditionalInfoChange(index, "ean", e.target.value)
          }
          value={productSections[index]?.ean}
        />
      </div>
      <div>
        <div className="mt-0">
          <CustomField
            type="select"
            name={`productSections[${index}].unitSize`}
            label={t("FORM.UNIT")}
            placeholder="Unit Size"
            options={optionsForUnitSize}
            handleChange={(e) =>
              handleAdditionalInfoChange(index, "unitSize", e.target.value)
            }
            value={productSections[index]?.unitSize || ""}
          />
        </div>
      </div>

      <div>
        <CustomField
          type="select"
          name={`productSections[${index}].additionalUnit`}
          label="Additional Unit (optional)"
          placeholder="e.g. PCS"
          options={optionsForUnitSize}
          handleChange={(e) =>
            handleAdditionalInfoChange(index, "additionalUnit", e.target.value)
          }
          value={productSections[index]?.additionalUnit || ""}
        />
      </div>
      {productSections[index]?.additionalUnit && (
        <div>
          <CustomField
            type="number"
            name={`productSections[${index}].conversionQty`}
            label={`${productSections[index]?.additionalUnit || "Units"} per ${productSections[index]?.unitSize || "unit"}`}
            placeholder="e.g. 12"
            handleChange={(e) =>
              handleAdditionalInfoChange(index, "conversionQty", e.target.value)
            }
            value={productSections[index]?.conversionQty || ""}
          />
        </div>
      )}

      <div>
        <CustomField
          type="text"
          name={`productSections[${index}].sku_number`}
          label={t("FORM.SKU")}
          placeholder="SKU Number"
          handleChange={(e) =>
            handleAdditionalInfoChange(index, "sku_number", e.target.value)
          }
          value={productSections[index]?.sku_number}
        />
      </div>
      {!isRawMaterials && (
        <div>
          <CustomField
            type="text"
            name={`productSections[${index}].mrp`}
            label="MRP"
            placeholder="MRP"
            handleChange={(e) =>
              handleAdditionalInfoChange(index, "mrp", e.target.value)
            }
            value={productSections[index]?.mrp || ""}
          />
        </div>
      )}
      <div>
        <CustomField
          type="date"
          name={`productSections[${index}].mfgDate`}
          label={t("FORM.MFG_DATE")}
          placeholder="MFG Date"
          handleChange={(e) =>
            handleAdditionalInfoChange(index, "mfgDate", e.target.value)
          }
          value={productSections[index]?.mfgDate || ""}
        />
      </div>
      <div>
        <CustomField
          type="date"
          name={`productSections[${index}].expDate`}
          label={t("SIDER.EXPIRY_DATE")}
          placeholder="Expiry Date"
          handleChange={(e) =>
            handleAdditionalInfoChange(index, "expDate", e.target.value)
          }
          value={productSections[index]?.expDate || ""}
        />
      </div>
      <div>
        <CustomField
          type="text"
          name={`productSections[${index}].openingStock`}
          label={t("FORM.OPENING_STOCK")}
          placeholder="Opening Stock"
          handleChange={(e) =>
            handleAdditionalInfoChange(index, "openingStock", e.target.value)
          }
          value={productSections[index]?.openingStock || ""}
          onKeyPress={onlyNumber}
        />
      </div>

      <div>
        <CustomField
          type="text"
          name={`productSections[${index}].lowStock`}
          label={t("INVENTORY.LOW_STOCK")}
          placeholder="Low Stock"
          handleChange={(e) =>
            handleAdditionalInfoChange(index, "lowStock", e.target.value)
          }
          value={productSections[index]?.lowStock || ""}
          onKeyPress={onlyNumber}
        />
      </div>
      <div>
        <CustomField
          type="select"
          name={`productSections[${index}].substituteProduct1`}
          placeholder="Substitute Product 1"
          label={t("FORM.SUBSTITUTE_1")}
          handleChange={(e) =>
            handleAdditionalInfoChange(
              index,
              "substituteProduct1",
              e.target.value,
            )
          }
          options={generateOptionsForSubstitute(
            isRawMaterials ? rawMaterialsLocal : products,
          )}
          value={productSections[index]?.substituteProduct1 || "no-select"}
        />
      </div>
      <div>
        <CustomField
          type="select"
          name={`productSections[${index}].substituteProduct2`}
          placeholder="Substitute Product 2"
          label={t("FORM.SUBSTITUTE_2")}
          handleChange={(e) =>
            handleAdditionalInfoChange(
              index,
              "substituteProduct2",
              e.target.value,
            )
          }
          options={generateOptionsForSubstitute(
            isRawMaterials ? rawMaterialsLocal : products,
          )}
          value={productSections[index]?.substituteProduct2 || "no-select"}
        />
      </div>
    </div>
  </div>
)}
                              <Modal
                                isOpen={isOpen}
                                width="70%"
                                closeModal={handleIsOpen}
                                modalHeader={
                                  isServices === true
                                    ? t("PAGINATION.SELECT_PRODUCT")
                                    : t("PAGINATION.SELECT_SERVICE")
                                }
                              >
                                <ProductSelection
                                  products={
                                    isServices === true
                                      ? service
                                      : isRawMaterials === true
                                        ? rawMaterialsLocal
                                        : products
                                  }
                                  handleSelectedProducts={
                                    handleSelectedProducts
                                  }
                                  handleIsOpen={handleIsOpen}
                                  isServices={
                                    isServices === true ? true : false
                                  }
                                  isRawMaterials={
                                    isRawMaterials === true ? true : false
                                  }
                                  isPurchase={true}
                                />
                              </Modal>
                              <Modal
                                isOpen={isOpenPitara}
                                width="70%"
                                closeModal={handleIsOpenPitara}
                                modalHeader={t("PAGINATION.SELECT_PRODUCT")}
                              >
                                <ProductSelection
                                  products={pitaraProducts}
                                  handleSelectedProducts={
                                    handleSelectedProducts
                                  }
                                  handleIsOpen={handleIsOpenPitara}
                                  isPitara={true}
                                />
                              </Modal>
                            </div>
                          ))}

                          {/* Add Product Buttons */}
                          <div className="flex justify-center gap-4 mt-4">
                            <button
                              type="button"
                              onClick={handleIsOpen}
                              className="px-4 py-2 text-sm font-medium text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20 hover:bg-blue-100 dark:hover:bg-blue-900/40 border border-blue-200 dark:border-blue-800 rounded-lg transition-colors flex items-center gap-2"
                              disabled={
                                products.length === 0 ||
                                values.orderStatus === "received"
                              }
                            >
                              <span className="h-5 w-5 flex items-center justify-center bg-blue-600 rounded-full">
                                <span className="text-white text-xs">+</span>
                              </span>
                              {t("FORM.SELECT_FROM_INVENTORY")}
                            </button>

                            {!isServices &&
                              business?.businessCategory === "Grocery" && (
                                <button
                                  type="button"
                                  onClick={handleIsOpenPitara}
                                  className="px-4 py-2 text-sm font-medium text-purple-600 dark:text-purple-400 bg-purple-50 dark:bg-purple-900/20 hover:bg-purple-100 dark:hover:bg-purple-900/40 border border-purple-200 dark:border-purple-800 rounded-lg transition-colors flex items-center gap-2"
                                  disabled={values.orderStatus === "received"}
                                >
                                  <span className="h-5 w-5 flex items-center justify-center bg-purple-600 rounded-full">
                                    <span className="text-white text-xs">
                                      +
                                    </span>
                                  </span>
                                  {t("FORM.ADD_FROM_INVENTORY_PITARA")}
                                </button>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-6">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                      {/* Order Details Card */}
                      <div className="min-w-0 lg:min-w-[400px] bg-gradient-to-br from-gray-50 to-white dark:from-[#170f2a] dark:to-[#1e153a] p-4 rounded-xl shadow-sm border border-gray-100 dark:border-gray-800 h-fit">
                        <div className="flex items-center justify-between mb-4">
                          <h4 className="text-sm font-semibold text-gray-800 dark:text-white flex items-center gap-1.5">
                            <div className="w-1.5 h-3.5 bg-blue-500 rounded-full"></div>
                            Order Details
                          </h4>
                          <span className="text-xs px-1.5 py-0.5 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-300 rounded-full whitespace-nowrap">
                            {values.orderStatus || "Draft"}
                          </span>
                        </div>

                        <div className="space-y-3">
                          {/* Date & Time Section */}
                          <div className="bg-white dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700 p-3">
                            <div className="grid grid-cols-2 gap-3">
                              <div className="min-w-0">
                                <CustomField
                                  type="date"
                                  name="intimationDate"
                                  label={t("FORM.PURCHASE_DATE")}
                                  handleChange={handleChange}
                                  value={values.intimationDate}
                                  className="text-xs"
                                  inputClass="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                />
                              </div>
                              <div className="min-w-0">
                                <CustomField
                                  type="time"
                                  name="intimationTime"
                                  label={t("FORM.PURCHASE_TIME")}
                                  handleChange={handleChange}
                                  value={values.intimationTime}
                                  setFieldValue={setFieldValue}
                                  className="text-xs"
                                  inputClass="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                />
                              </div>
                            </div>
                          </div>

                          {/* Expected Delivery Section */}
                          <div className="bg-white dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700 p-3">
                            <div className="grid grid-cols-2 gap-3">
                              <div className="min-w-0">
                                <CustomField
                                  type="date"
                                  name="expectedDate"
                                  label={t("SIDER.EXPECTED_DELIVERY")}
                                  handleChange={handleChange}
                                  value={values.expectedDate}
                                  className="text-xs"
                                  inputClass="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                />
                              </div>
                              <div className="min-w-0">
                                <CustomField
                                  type="time"
                                  name="expectedTime"
                                  label={t("FORM.EXPECTED_DELIVERY_TIME")}
                                  placeholder="Expected Delivery Time"
                                  handleChange={handleChange}
                                  value={values.expectedTime}
                                  setFieldValue={setFieldValue}
                                  className="text-xs"
                                  inputClass="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                />
                              </div>
                            </div>
                          </div>

                          {/* Status Section */}
                          <div className="bg-white dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700 p-3">
                            <div className="grid grid-cols-2 gap-3">
                              <div className="min-w-0">
                                <CustomField
                                  type="select"
                                  name="orderStatus"
                                  label={t("SIDER.ORDER_STATUS")}
                                  handleChange={handlechangeForOrderStatus}
                                  value={values.orderStatus}
                                  options={optionsForOrderStatus}
                                  className="text-xs"
                                  selectPropClass="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                />
                              </div>
                              <div className="min-w-0">
                                <div className="space-y-1">
                                  <CustomField
                                    type="select"
                                    name="transactionStatus"
                                    label={t("SIDER.TRANSACTION_STATUS")}
                                    handleChange={(e) => {
                                      if (
                                        !item &&
                                        ["partialy-paid", "Advance"].includes(
                                          e.target.value,
                                        )
                                      ) {
                                        setIsOpenPayPartial(true);
                                      }
                                      handleChange(e);
                                    }}
                                    value={values.transactionStatus}
                                    options={optionsForTransactionStatus.filter(
                                      (option) =>
                                        !(
                                          values.orderStatus === "approved" ||
                                          values.orderStatus === "shipped"
                                        ) || option.value !== "not_paid",
                                    )}
                                    className="text-xs"
                                    selectPropClass="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                    disabled={values.orderStatus === "ordered"}
                                  />
                                  {values.orderStatus === "ordered" && (
                                    <span className="text-xs text-red-500 block">
                                      Transaction status cannot be changed in
                                      draft mode
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Combined Notes, Reference & Logistics Section - Collapsible */}
                          <div className="bg-white dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700">
                            <button
                              type="button"
                              onClick={() =>
                                setShowAdditionalInfo(!showAdditionalInfo)
                              }
                              className="flex items-center justify-between w-full p-3 text-left hover:bg-gray-50 dark:hover:bg-gray-800/70 rounded-lg transition-colors"
                            >
                              <div className="flex items-center gap-1.5">
                                <div className="w-1.5 h-1.5 rounded-full bg-amber-500"></div>
                                <span className="text-xs font-medium text-gray-700 dark:text-gray-300">
                                  Additional Information
                                </span>
                              </div>
                              <div className="flex items-center gap-2">
                                {showAdditionalInfo ? (
                                  <>
                                    <span className="text-xs text-blue-600 dark:text-blue-400">
                                      Hide Details
                                    </span>
                                    <FaChevronUp className="w-3 h-3 text-blue-600 dark:text-blue-400" />
                                  </>
                                ) : (
                                  <>
                                    <span className="text-xs text-blue-600 dark:text-blue-400">
                                      Show Details
                                    </span>
                                    <FaChevronDown className="w-3 h-3 text-blue-600 dark:text-blue-400" />
                                  </>
                                )}
                              </div>
                            </button>

                            {showAdditionalInfo && (
                              <div className="px-3 pb-3 space-y-4 border-t border-gray-100 dark:border-gray-700 pt-3">
                                {/* Notes Section */}
                                <div className="space-y-2">
                                  <label className="text-xs font-medium text-gray-700 dark:text-gray-300 flex items-center gap-1.5">
                                    <div className="w-1.5 h-1.5 rounded-full bg-gray-500"></div>
                                    Notes
                                  </label>
                                  <CustomField
                                    type="text"
                                    name="buyNote"
                                    label="Additional Notes"
                                    placeholder="Add any notes or comments here"
                                    handleChange={handleChange}
                                    value={values.buyNote}
                                    className="text-xs"
                                    inputClass="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                  />
                                </div>

                                {/* Reference Information Section */}
                                <div className="space-y-2">
                                  <div className="grid grid-cols-2 gap-3">
                                    <div className="min-w-0">
                                      <CustomField
                                        type="text"
                                        name="refInvoiceNo"
                                        label="Reference Invoice Number"
                                        placeholder="Ref. Invoice No"
                                        handleChange={handleChange}
                                        value={values.refInvoiceNo}
                                        className="text-xs"
                                        inputClass="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                      />
                                    </div>
                                    <div className="min-w-0">
                                      <CustomField
                                        type="text"
                                        name="assignedAgent"
                                        label="Assigned Agent"
                                        placeholder="Agent Name"
                                        handleChange={handleChange}
                                        value={values.assignedAgent}
                                        className="text-xs"
                                        inputClass="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Logistic Information Section */}
                                <div className="space-y-2">
                                  <div className="grid grid-cols-2 gap-3">
                                    <div className="min-w-0">
                                      <CustomField
                                        type="text"
                                        name="LRNumber"
                                        label="LR Number"
                                        placeholder="Enter LR Number"
                                        value={values.LRNumber || ""}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          setFieldValue("LRNumber", value);
                                          handleCommonChange("LRNumber", value);
                                        }}
                                        className="text-xs"
                                        inputClass="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                      />
                                    </div>
                                    <div className="min-w-0">
                                      <CustomField
                                        type="text"
                                        name="logisticName"
                                        label="Logistic Company"
                                        placeholder="Company Name"
                                        value={values.logisticName || ""}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          setFieldValue("logisticName", value);
                                          handleCommonChange(
                                            "logisticName",
                                            value,
                                          );
                                        }}
                                        className="text-xs"
                                        inputClass="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                      />
                                    </div>
                                  </div>
                                  <div className="min-w-0">
                                    <CustomField
                                      type="text"
                                      name="logisticVehicle"
                                      label="Vehicle Number"
                                      placeholder="Vehicle No"
                                      value={values.logisticVehicle || ""}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        setFieldValue("logisticVehicle", value);
                                        handleCommonChange(
                                          "logisticVehicle",
                                          value,
                                        );
                                      }}
                                      className="text-xs"
                                      inputClass="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Pricing Summary Card */}
                      <div className="min-w-0 lg:min-w-[400px] bg-gradient-to-br from-gray-50 to-white dark:from-[#170f2a] dark:to-[#1e153a] p-4 rounded-xl shadow-sm border border-gray-100 dark:border-gray-800 h-fit">
                        <div className="flex items-center justify-between mb-4">
                          <h4 className="text-sm font-semibold text-gray-800 dark:text-white flex items-center gap-1.5">
                            <div className="w-1.5 h-3.5 bg-emerald-500 rounded-full"></div>
                            Pricing Summary
                          </h4>
                          <span className="text-xs px-1.5 py-0.5 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-300 rounded-full whitespace-nowrap">
                            {productSections.length}{" "}
                            {productSections.length === 1 ? "Item" : "Items"}
                          </span>
                        </div>

                        <div className="space-y-3">
                          {/* Additional Discount */}
                          {!hideDiscount && (<div className="bg-white dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700 p-3">
                            <div className="flex items-center justify-between mb-2">
                              <label className="text-xs font-medium text-gray-700 dark:text-gray-300 flex items-center gap-1.5">
                                <div className="w-1.5 h-1.5 rounded-full bg-amber-500"></div>
                                {t("INVOICE.ADDITIONAL_DISCOUNT")}
                              </label>
                              <span className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
                                {values.additionalDiscount.length} applied
                              </span>
                            </div>

                            <div className="space-y-1.5">
                              {values.additionalDiscount.map((item, index) => (
                                <div
                                  key={index}
                                  className="flex items-center gap-1.5 p-1.5 bg-gray-50 dark:bg-gray-800/80 rounded-lg"
                                >
                                  <input
                                    name={`additionalDiscount.${index}.label`}
                                    type="text"
                                    placeholder="Discount label"
                                    className="flex-1 min-w-0 py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                    value={item.label}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <div className="flex items-center gap-1 flex-1 min-w-0">
                                    <select
                                      name={`additionalDiscount.${index}.type`}
                                      className="shrink-0 w-14 py-1.5 px-1.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                      value={item.type || "%"}
                                      onChange={handleChange}
                                    >
                                      <option value="%">%</option>
                                      <option value="₹">₹</option>
                                    </select>
                                    <input
                                      name={`additionalDiscount.${index}.amount`}
                                      type="text"
                                      placeholder="0.00"
                                      className="flex-1 min-w-0 py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                      value={item.amount}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      maxLength={10}
                                    />
                                  </div>
                                  <button
                                    type="button"
                                    onClick={() => removeDiscount(index)}
                                    className="flex-shrink-0 p-1.5 text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
                                    aria-label="Remove discount"
                                  >
                                    <BsTrash className="h-3 w-3" />
                                  </button>
                                </div>
                              ))}
                            </div>

                            <button
                              type="button"
                              onClick={addDiscount}
                              className="mt-2 w-full py-1.5 px-2.5 border border-dashed border-gray-300 dark:border-gray-600 hover:border-blue-500 dark:hover:border-blue-400 rounded-lg text-xs text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-300 flex items-center justify-center gap-1.5 transition-colors"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-3 w-3 flex-shrink-0"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                />
                              </svg>
                              Add Discount
                            </button>
                          </div>)}

                          {/* Additional Fee */}
                          <div className="bg-white dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700 p-3">
                            <div className="flex items-center justify-between mb-2">
                              <label className="text-xs font-medium text-gray-700 dark:text-gray-300 flex items-center gap-1.5">
                                <div className="w-1.5 h-1.5 rounded-full bg-rose-500"></div>
                                {t("INVOICE.ADDITIONAL_FEE")}
                              </label>
                              <span className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
                                {values.additionalFee.length} applied
                              </span>
                            </div>

                            <div className="space-y-1.5">
                              {values.additionalFee.map((item, index) => (
                                <div
                                  key={index}
                                  className="flex items-center gap-1.5 p-1.5 bg-gray-50 dark:bg-gray-800/80 rounded-lg"
                                >
                                  <input
                                    name={`additionalFee.${index}.label`}
                                    type="text"
                                    placeholder="Fee label"
                                    className="flex-1 min-w-0 py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                    value={item.label}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <div className="flex items-center gap-1 flex-1 min-w-0">
                                    <select
                                      name={`additionalFee.${index}.type`}
                                      className="shrink-0 w-14 py-1.5 px-1.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                      value={item.type || "%"}
                                      onChange={handleChange}
                                    >
                                      <option value="%">%</option>
                                      <option value="₹">₹</option>
                                    </select>
                                    <input
                                      name={`additionalFee.${index}.amount`}
                                      type="text"
                                      placeholder="0.00"
                                      className="flex-1 min-w-0 py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                      value={item.amount}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      maxLength={10}
                                    />
                                  </div>
                                  <button
                                    type="button"
                                    onClick={() => removeFee(index)}
                                    className="flex-shrink-0 p-1.5 text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
                                    aria-label="Remove fee"
                                  >
                                    <BsTrash className="h-3 w-3" />
                                  </button>
                                </div>
                              ))}
                            </div>

                            <button
                              type="button"
                              onClick={addFee}
                              className="mt-2 w-full py-1.5 px-2.5 border border-dashed border-gray-300 dark:border-gray-600 hover:border-rose-500 dark:hover:border-rose-400 rounded-lg text-xs text-gray-600 dark:text-gray-400 hover:text-rose-600 dark:hover:text-rose-300 flex items-center justify-center gap-1.5 transition-colors"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-3 w-3 flex-shrink-0"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                />
                              </svg>
                              Add Fee
                            </button>
                          </div>

                          {/* Payment Status Section (only for Advance/Partial payments) */}
                          {(values.transactionStatus === "Advance" ||
                            values.transactionStatus === "partialy-paid") && (
                            <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-800 p-3">
                              <h5 className="text-xs font-medium text-blue-700 dark:text-blue-300 mb-2 flex items-center gap-1.5">
                                <svg
                                  className="w-3 h-3 flex-shrink-0"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm12 2a1 1 0 10-2 0v1H4V6a1 1 0 011-1h12a1 1 0 011 1z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                {values.transactionStatus === "Advance"
                                  ? "Advance Payment"
                                  : "Partial Payment"}
                              </h5>

                              <div className="space-y-2">
                                {item &&
                                  (item.transactionStatus === "Advance" ||
                                    item.transactionStatus ===
                                      "partialy-paid") && (
                                    <>
                                      <div className="flex justify-between items-center p-1.5">
                                        <span className="text-xs text-gray-700 dark:text-gray-300">
                                          {values.transactionStatus ===
                                          "Advance"
                                            ? "Advance Paid"
                                            : "Partial Paid"}
                                        </span>
                                        <span className="text-xs font-semibold text-green-600 dark:text-green-400 whitespace-nowrap">
                                          {getCurrencySymbol(
                                            business?.currency,
                                          )}
                                          {item.totalPaid || 0}
                                        </span>
                                      </div>
                                      <div className="flex justify-between items-center p-1.5">
                                        <span className="text-xs text-gray-700 dark:text-gray-300">
                                          Remaining Amount
                                        </span>
                                        <span className="text-xs font-semibold text-blue-600 dark:text-blue-400 whitespace-nowrap">
                                          {getCurrencySymbol(
                                            business?.currency,
                                          )}
                                          {item.remainingTransactionAmount || 0}
                                        </span>
                                      </div>
                                    </>
                                  )}
                              </div>
                            </div>
                          )}

                          {/* Total Amount */}
                          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/30 dark:to-indigo-900/30 rounded-lg border border-blue-200 dark:border-blue-800 p-3">
                            <div className="flex justify-between items-center">
                              <div className="min-w-0">
                                <span className="text-xs font-semibold text-gray-800 dark:text-white">
                                  {t("FORM.TRANSACTION_AMOUNT")}
                                </span>
                                {(values.transactionStatus === "Advance" ||
                                  values.transactionStatus ===
                                    "partialy-paid") && (
                                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                    {values.transactionStatus === "Advance"
                                      ? "After advance payment"
                                      : "After partial payment"}
                                  </p>
                                )}
                              </div>
                              <span className="text-sm font-bold text-blue-600 dark:text-blue-400 whitespace-nowrap">
                                {getCurrencySymbol(business?.currency)}
                                {calculateTotalTransactionAmount(values)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-6">
                    {item ? (
                      item.transactionStatus === "Advance" ? (
                        <div className="flex justify-end gap-6">
                          <button
                            type="button"
                            className="w-full lg:w-1/2 py-2 px-2 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded transition-colors"
                            onClick={handleIsOpenForPayParial}
                          >
                            <span>{t("COMMON.SAVE")}</span>
                          </button>
                        </div>
                      ) : item.transactionStatus === "partialy-paid" ? (
                        <div className="flex justify-end gap-6">
                          <button
                            type="button"
                            className="w-full lg:w-1/2 py-2 px-2 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded transition-colors"
                            onClick={handleIsOpenForPayParial}
                          >
                            <span>Pay More Partial&nbsp;</span>
                          </button>
                        </div>
                      ) : (
                        <button
                          type="submit"
                          disabled={purchaseIsLoading}
                         onClick={() => {
  if (["Advance", "partialy-paid"].includes(values?.transactionStatus)) {
    handleIsOpenForPayParial();
  } else {
    handleIsOpenForFullPayment();
  }
}}
                          className="w-full py-2 px-2 text-white bg-blue-600 hover:bg-blue-700 font-bold rounded transition-colors"
                        >
                          <span className="flex items-center justify-center gap-2">
                            {t("FORM.UPADTE_PURCHASE")}
                            {purchaseIsLoading && (
                              <BeatLoader color="#ffffff" size={12} />
                            )}
                          </span>
                        </button>
                      )
                    ) : (
                      <div className="flex justify-end gap-6">
                        <button
                          type="button"
                          className="w-full lg:w-2/4 py-2 mb-1 px-1.5 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
                          onClick={() => {
  if (["Advance", "partialy-paid"].includes(values?.transactionStatus)) {
    handleIsOpenForPayParial();
  } else {
    handleIsOpenForFullPayment();
  }
}}
                          disabled={
                            !values.fullName ||
                            !values.supplierMobile ||
                            !section.productName ||
                            !section.purchasePrice ||
                            purchaseIsLoading
                          }
                          title={
                            !values.fullName || !values.supplierMobile
                              ? "Please enter supplier details to proceed"
                              : !section.productName && !section.purchasePrice
                                ? "Please enter Product name and Purchase Price to proceed"
                                : ""
                          }
                        >
                          <span className="flex items-center justify-center gap-2">
                            {t("COMMON.SAVE")}
                            {purchaseIsLoading && (
                              <BeatLoader color="#ffffff" size={12} />
                            )}
                          </span>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <VariantModal
                isOpen={isVariantModalOpen}
                onClose={() => setIsVariantModalOpen(false)}
                product={
                  currentVariantIndex !== null
                    ? productSections[currentVariantIndex]
                    : null
                }
                variantData={variantModalData}
                setVariantData={setVariantModalData}
                totalVariantQuantity={totalVariantQuantity}
                setTotalVariantQuantity={setTotalVariantQuantity}
                business={business}
                onSave={saveVariantsFromModal}
              />
              <Modal
                isOpen={isOpenFullPayment}
                width="20%"
                closeModal={handleIsOpenForFullPayment}
                modalHeader="Payment Options"
              >
                {purchaseIsLoading ? (
                  <div className="flex justify-center items-center h-full">
                    <BeatLoader color="#5556d3" size={12} />
                  </div>
                ) : (
                  <PaymentOptions
                    handleChangePaymentMethod={handleChangePaymentMethod}
                    values={values}
                    totalAmount={calculateTotalTransactionAmount(values)}
                  />
                )}
              </Modal>
              <Modal
                isOpen={showInvoiceUploader}
                width="40%"
                closeModal={() => setShowInvoiceUploader(false)}
                modalHeader="Upload Invoice for Auto-fill"
              >
                <div className="p-4">
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                    Upload an invoice (PDF or image) and we'll automatically
                    extract the data and fill the form.
                  </p>
                  <InvoiceUploader
                    onDataExtracted={handleInvoiceDataExtracted}
                    isDisabled={
                      item &&
                      (item.orderStatus === "approved" ||
                        item.orderStatus === "received")
                    }
                    businessUuid={finalBusinessUuid}
                  />
                </div>
              </Modal>
              <Modal
                isOpen={isOpenPayPartial}
                width="40%"
                closeModal={handleIsOpenForPayParial}
                modalHeader={
                  item && item?.transactionStatus === "Advance"
                    ? "Pay Advance"
                    : "Pay Partial"
                }
              >
                {purchaseIsLoading ? (
                  <div className="flex justify-center items-center h-full">
                    <BeatLoader color="#5556d3" size={12} />
                  </div>
                ) : (
                  <SalePaylater
                    handleChangePaymentMethod={handleChangePaymentMethod}
                    totalAmount={
                      item
                        ? item?.transactionStatus === "Advance" ||
                          item?.transactionStatus === "partialy-paid"
                          ? item?.remainingTransactionAmount
                          : item?.transactionAmount
                        : calculateTotalTransactionAmount(values)
                    }
                    values={values}
                    isPurchase={true}
                    tickAdvance={
                      item?.transactionStatus === "Advance" ||
                      values.transactionStatus === "Advance"
                        ? true
                        : false
                    }
                    advanceAmount={item && item?.advanceAmount}
                    tickPartial={
                      (item && item?.isPartial == true) ||
                      values.transactionStatus == "partialy-paid"
                        ? true
                        : false
                    }
                    partialAmount={item?.totalPaid}
                  />
                )}
              </Modal>
  <Modal
  isOpen={showReceiptOptions}
  width="600px"
  closeModal={() => {
    setShowReceiptOptions(false);
    setAskSalePrice(false);
    setPendingPurchaseValues(null);
    setPendingUpdateValues(null);
    setBatchNumbers({});
  }}
  modalHeader="How would you like to receive this purchase?"
>
  <div className="space-y-4">
    {askSalePrice ? (
      <>
        <p className="text-sm text-gray-600 dark:text-gray-300">
          Enter sale price and batch number for each item.
        </p>

        <div className="space-y-3 max-h-[55vh] overflow-y-auto pr-1">
         {productSections.map((section, idx) => {
  const hasVar =
    section.hasVariants &&
    Array.isArray(section.variants) &&
    section.variants.length > 0;
  const varQty = totalVariantQuantityForSection(section);
  const orderedQty = Number(section.quantity) || 0;
  const mismatch = hasVar && varQty !== orderedQty;

  const purchaseUnit = getPurchasePricePerUnit(section);
  const saleUnit = Number(salePrices[idx]) || 0;
  const margin = saleUnit - purchaseUnit;
  const marginPct =
    purchaseUnit > 0 ? (margin / purchaseUnit) * 100 : 0;

  return (
    <div
      key={idx}
      className="border border-gray-200 dark:border-gray-700 rounded-lg p-3 space-y-2 bg-white dark:bg-gray-800/40"
    >
      <div className="font-medium text-sm truncate text-gray-900 dark:text-white">
        {section.productName || `Item ${idx + 1}`}
      </div>

      <div className="grid grid-cols-3 gap-2">
        {/* Purchase Price (read-only) */}
        <div>
          <label className="text-xs text-gray-500 dark:text-gray-400">
            Purchase Price
          </label>
          <input
            type="text"
            value={purchaseUnit.toFixed(2)}
            readOnly
            className="w-full py-1.5 px-2 border border-gray-200 dark:border-gray-600 dark:bg-gray-700/60 bg-gray-50 rounded text-sm text-gray-600 dark:text-gray-300 cursor-not-allowed"
          />
        </div>

        {/* Sale Price */}
        <div>
          <label className="text-xs text-gray-500 dark:text-gray-400">
            Sale Price
          </label>
          <input
            type="text"
            placeholder="Sale price"
            value={salePrices[idx] ?? ""}
            onKeyPress={onlyNumberdesimal}
            onChange={(e) =>
              setSalePrices((prev) => ({
                ...prev,
                [idx]: e.target.value,
              }))
            }
            className="w-full py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded text-sm"
          />
        </div>

        {/* Batch Number */}
        <div>
          <label className="text-xs text-gray-500 dark:text-gray-400">
            Batch Number
          </label>
          <input
            type="text"
            placeholder="Batch no."
            value={batchNumbers[idx] ?? ""}
            onChange={(e) =>
              setBatchNumbers((prev) => ({
                ...prev,
                [idx]: e.target.value,
              }))
            }
            className="w-full py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded text-sm"
          />
        </div>
      </div>

      {/* Margin / Loss — same style as PurchaseProductList */}
      {purchaseUnit > 0 && saleUnit > 0 && (
        <div
          className={`text-xs font-medium ${
            margin < 0
              ? "text-red-600 dark:text-red-400"
              : "text-green-600 dark:text-green-400"
          }`}
        >
          {margin < 0 ? "Loss" : "Margin"}:{" "}
          {getCurrencySymbol(business?.currency)}
          {Math.abs(margin).toFixed(2)} ({marginPct.toFixed(1)}%)
        </div>
      )}

      {/* Variant status + Edit Variants — mismatch (red) */}
      {hasVar && mismatch && (
        <div className="flex items-center justify-between gap-2 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded px-2 py-1.5">
          <div className="text-xs text-red-700 dark:text-red-300 truncate">
            ⚠ Variant qty ({varQty}) ≠ purchase qty ({orderedQty}). Fix
            before adding to inventory.
          </div>
          <button
            type="button"
            onClick={() => {
              setVariantSetupIndex(idx);
              setVariantSetupData({
                variantType: section.variantType || "size",
                variantConfig: section.variantConfig || {
                  color: [],
                  size: [],
                  model: [],
                  custom: [],
                },
                variants: JSON.parse(JSON.stringify(section.variants)),
              });
            }}
            className="text-xs px-2 py-1 bg-red-600 hover:bg-red-700 text-white rounded flex-shrink-0"
          >
            Edit Variants
          </button>
        </div>
      )}

      {/* Variant status + Edit Variants — matched (green) */}
      {hasVar && !mismatch && (
        <div className="flex items-center justify-between gap-2 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded px-2 py-1.5">
          <div className="text-xs text-green-700 dark:text-green-300 truncate">
            {section.variants.length} variant(s) • {varQty} units ✓
          </div>
          <button
            type="button"
            onClick={() => {
              setVariantSetupIndex(idx);
              setVariantSetupData({
                variantType: section.variantType || "size",
                variantConfig: section.variantConfig || {
                  color: [],
                  size: [],
                  model: [],
                  custom: [],
                },
                variants: JSON.parse(JSON.stringify(section.variants)),
              });
            }}
            className="text-xs px-2 py-1 bg-green-600 hover:bg-green-700 text-white rounded flex-shrink-0"
          >
            Edit Variants
          </button>
        </div>
      )}
    </div>
  );
})}
        </div>

        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => {
              setAskSalePrice(false);
              setBatchNumbers({});
            }}
            disabled={purchaseIsLoading}
            className="w-1/3 rounded bg-gray-200 px-4 py-2 text-gray-800 hover:bg-gray-300 dark:bg-gray-700 dark:text-white disabled:opacity-60"
          >
            Back
          </button>
          <button
            type="button"
            onClick={handleConfirmSalePrices}
            disabled={purchaseIsLoading}
            className="w-2/3 rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-60"
          >
            {isRawMaterials ? "Add to warehouse" : "Add to inventory"}
          </button>
        </div>

        {purchaseIsLoading && (
          <div className="flex justify-center">
            <BeatLoader color="#5556d3" size={10} />
          </div>
        )}
      </>
    ) : (
      <>
        <p className="text-sm text-gray-600 dark:text-gray-300">
          {isRawMaterials
            ? "Choose whether these raw materials have arrived at your warehouse."
            : "Choose whether these products have arrived at your inventory."}
        </p>
        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={startReceiveNow}
            disabled={purchaseIsLoading}
            className="w-full rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-60"
          >
            {isRawMaterials
              ? "Yes, add to warehouse now"
              : "Yes, add to inventory now"}
          </button>
          <button
            type="button"
            onClick={() => handleReceiptChoice("partialDelivery")}
            disabled={purchaseIsLoading}
            className="w-full rounded border border-blue-600 px-4 py-2 text-blue-700 hover:bg-blue-50 dark:text-blue-300 dark:hover:bg-slate-800 disabled:opacity-60"
          >
            Partial delivery — enter received quantities
          </button>
          {purchaseIsLoading && (
            <div className="flex justify-center">
              <BeatLoader color="#5556d3" size={10} />
            </div>
          )}
        </div>
      </>
    )}
  </div>
              </Modal>

              <div style={{ position: "relative", zIndex: 60 }}>
                {variantSetupIndex !== null && variantSetupData && (
                  <VariantModal
                    isOpen={true}
                    onClose={() => {
                      setVariantSetupIndex(null);
                      setVariantSetupData(null);
                    }}
                    product={productSections[variantSetupIndex]}
                    variantData={variantSetupData}
                    setVariantData={setVariantSetupData}
                    totalVariantQuantity={(variantSetupData.variants || []).reduce(
                      (s, v) => s + (Number(v.quantity) || 0),
                      0,
                    )}
                    setTotalVariantQuantity={() => {}}
                    business={business}
                    onSave={() => {
                      const target = productSections[variantSetupIndex];
                      const sectionQty = Number(target?.quantity) || 0;
                      const totalVarQty = (variantSetupData.variants || []).reduce(
                        (s, v) => s + (Number(v.quantity) || 0),
                        0,
                      );
                      if (totalVarQty !== sectionQty) {
                        toast.error(
                          `Total variant quantity (${totalVarQty}) must equal ordered quantity (${sectionQty}).`,
                        );
                        return;
                      }
                      setProductSections((prev) => {
                        const copy = [...prev];
                        copy[variantSetupIndex] = {
                          ...copy[variantSetupIndex],
                          hasVariants: true,
                          variantType: variantSetupData.variantType,
                          variantConfig: variantSetupData.variantConfig,
                          variants: variantSetupData.variants,
                        };
                        return copy;
                      });
                      setVariantSetupIndex(null);
                      setVariantSetupData(null);
                      toast.success(
                        "Variants saved. Variant quantity now matches purchase quantity.",
                      );
                    }}
                  />
                )}
              </div>
          
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default NewBuy;
